import { observable } from 'mobx'

import debounce from 'lodash/debounce'
import { SHIPPING_TYPE, PAYMENT_TYPE, GPS, SEPA } from 'src/utils/constant'
import TagManager from 'react-gtm-module'
import {
  getCheckoutProduct,
  i18nTranslate,
  trackUTTConversion,
  trackCheckoutGiftReceipt,
  getLocaleCodeFromUrl,
  isB2BAccount,
  isB2BUser,
  getBrowserIpAddress,
  trackErrorInInstana,
  getShoppingContext,
  clearShoppingContext,
  getBrowserType,
  getGuestSignupOrigin,
  isGuestCheckoutEnabledForWeb,
  checkMysiteOrPersonalOffer,
  getUTMInfo,
  getUTTInfo,
  application,
  getCheckoutGTMPageData,
  isExpressCheckout,
  isSubscriptionOverrideCheckoutPage,
  enableBillingAddressRequired,
  isGPSEnabled,
  getDefaultPaymentMethod,
  trackCustomCheckoutEvent,
  isINMarket,
  getMysiteCartUrl,
  enableNewFeature,
  trackPathToPurchasePurchaseEvent,
  trackSalesAIPixelPurchaseEvent,
  getGPSConfigValue,
  isFeatureEnabled,
  getGPSConfig,
  enablePORedesignFeature,
  hasProductOfferPercentageDiscount,
  isTwikeyPaymentName,
  isSepaPaymentType,
  findGpsOptionKey,
  isExpressCart,
  TWIKEY_PAYMENT_NAME,
  isExternalGPSCreditCardPaymentName,
  getConfiguredGPSCreditCardOption,
  isPaymetricGPSCreditCardOption,
  isPaymetric3DSProcessor,
  hasCardPaymentOnCart,
  GPS_CCARD_TYPE,
  resolveGpsPaymentType,
  getGpsRoutedCreditCardOption,
  getGpsOptionId,
  BANK_TRANSFER_TYPE,
  validateMaxLengthForAddressLine,
} from 'src/utils'
import { getPOAnalyticsSessionId } from 'src/utils/poAnalyticsUtils'
import { PO_AUDIT_ORDER_OFFERID_KEY } from 'src/utils/constant'

import { CommonContainer } from 'src/models/Common'
import {
  cartContainer,
  customerContainer,
  tokenExContainer,
  paymetricContainer,
  savedCardsContainer,
  loyaltyContainer,
  addressContainer,
  nlxxConfigContainer,
  accountsAddressContainer,
  accountsContainer,
} from 'src/models'
import { toastState } from 'src/views/components'
import { storeContainer } from 'src/models/Store'
import {
  getAppConfig,
  getSessionStorage,
  APPConfig,
  getLocalStorage,
  setSessionStorage,
  deleteFromSessionStorage,
  convertToBoolean,
  deleteCookie,
  setLocalStorage,
} from 'config/appConfig'
import { IS_BROWSER } from 'src/utils/application'
import { parsePhoneNumber } from 'libphonenumber-js'
import isEmpty from 'lodash/isEmpty'
import { pageNames } from 'src/routes/pathParams'
import { alertMessageKeys } from 'src/views/components/CartBlock/fixture'
import { isToHaveOptionalPhoneSchema } from 'src/views/addresses/addressUtils'
import { checkIsNativeApp } from 'src/utils/reactNativeAppUtils'
import { isToShowLegalAddressChanges } from 'src/deps'
import { setInsiderTransactionData } from 'src/utils/insider'
import ContentStack from 'src/api/contentStack'
import {
  getMysiteSponsor,
  getPoSponsorId,
  isEquinoxMysite,
  isEquinoxPOSite,
} from 'src/utils/mySiteUtils'
import { mysiteContainer } from '../Mysite'
import { overlayState } from 'src/views/components/Overlay'
import {
  getRestrictedCardType,
  isCardProviderRestricted,
  isPaymetricEnabled,
  normalizePaymetricCardType,
} from 'src/utils/paymentContainerHelper'

const PICKUP_SHIPPING_METHOD_ID =
  APPConfig?.getAppConfig()?.pickupShippingMethodId || 'PickUpPoint'

/**
 * shippingAddress object contains the shipping address fields for checkout.
 * Includes address lines, city, state, country, phone number, etc.
 */
const shippingAddress = {
  addressLine1: '1 front street',
  addressLine2: '',
  canReceiveSMS: false,
  city: 'San Francisco',
  continue: '',
  country: 'US',
  email: '',
  firstName: 'name',
  lastName: 'as',
  middleName: '',
  phone: '9579659952',
  state: 'CA',
  zip: '10001',
}

/**
 * CheckoutContainer class extends CommonContainer.
 * This is likely the main container class for managing checkout state and logic.
 */
class CheckoutContainer extends CommonContainer {
  @observable orderId = ''
  @observable defaultFlag = false
  @observable alipayResponse = {}
  @observable storeCreditInputFieldValue = ''
  @observable isPaymentCallsInProgress = false
  @observable giftPayLoad = false
  @observable giftMessage = ''
  @observable dropShippingPayLoad = false
  @observable paypalCheckout = false
  @observable applePayCheckout = false
  @observable gPayCheckout = false
  @observable addressLists = null
  @observable alipayInCart = false
  @observable activeSubmitOrderButton = true
  @observable activePath = ''
  @observable selectedMarket = storeContainer.defaultShippingRegion
  @observable paymentBillingSameAsShippingFlag = false
  @observable isKlarnaPaymentAdded = false
  @observable isToInitiateKlarnaPayment = false
  @observable addPaymentToProfile = customerContainer.isRegisterUser
    ? true
    : false
  @observable isPaymentApiInProgress = false
  @observable paymentDeletionInProgress = false
  @observable isCouponPaid = cartContainer?.cartResponse?.promotionDetails
    ?.codes
    ? true
    : false
  @observable isLoyaltyPaid =
    cartContainer?.cartResponse?.payments?.find(
      item => item?.type?.toLocaleLowerCase() == 'loyalty'
    ) || cartContainer?.cartResponse?.loyaltyDetails?.points
      ? true
      : false
  @observable isStoreCreditsPaid = cartContainer?.cartResponse?.payments?.find(
    item => item?.type == 'STORECREDIT'
  )
    ? true
    : false
  @observable isToDisableSubmitOrderButton = false
  @observable isToDisablePaymentContinueBtn = false
  @observable globalPaymentResponse = {}
  @observable globalPaymentOptionsListResponse = {}
  @observable globalPaymentInstallmentsResponse = {}
  @observable isGlobalPaymentCallInProgress = false
  @observable isToInitiateGlobalPayment = false
  @observable enableAutoSubmit = false
  @observable pickupLocationTimeoutId = null
  @observable autoPaymentSuccess = false
  // DO NOT set this from anywhere else — it will invoke handleSubmitClick() unexpectedly and cause duplicate orders.
  @observable triggerExpressSubmit = false
  @observable klarnaInitiateResponse = {}
  @observable appliedCouponCodes =
    cartContainer?.cartResponse?.promotionDetails?.codes || []
  @observable expressPaymentAdded = false
  @observable selectedPaymentType = ''
  @observable showExpressCheckoutDrawer = false
  @observable showExpressCheckoutModalBody = false
  @observable renderExpressPDPCart = false
  @observable isLegalAddressSameAsShipping = 'false'
  @observable isLegalAddressPreferenceSet = false
  /** Set only by a genuine radio answer - distinct from isLegalAddressPreferenceSet, which the default-address checkbox also sets */
  @observable isLegalAddressRadioAnsweredByShopper = false
  @observable isUserHasLegalAddress = false
  @observable accountsTaxIdResponse = {}
  @observable legalTaxInputJsonResponse = {}
  @observable isEditAddressFormEnabled = false
  @observable isShippingContinueClicked = false
  @observable isShippingAddNewFormOpen = false
  @observable initiallySelectedAddress = {}
  @observable currentPaymentTypeTab = ''
  @observable checkoutInstallmentFrequency = ''
  @observable wirepayment_nextgen_payment_method_text = ''
  @observable isTaxFormDataSubmited = false
  @observable isPaymentCancelled = false
  @observable isTopSectionExpressPaymentSelected = false
  @observable isLegalAddressAdded = false
  @observable enableShowAddressList = false
  @observable isItemsNotDeliverableErrorIN = false
  @observable isInvalidPhoneCountryCodeIN = false
  @observable disableSubmitButtonAsItemsNotDeliverable = false
  @observable iBanValue = ''
  @observable iBanValidationStatus = {
    isEmptyIban: true,
    isValidIban: false,
    isCountryCodeMismatch: false,
    hasError: true,
  }
  // True while the new-SEPA IBAN input is mounted. Authoritative signal for
  // submit validation, since selectedPaymentType is rewritten by several
  // express-checkout handlers while the input is still on screen.
  @observable isSepaIbanEntryActive = false
  @observable recipientName = ''
  @observable recipientPhone = ''

  /**
   * Handles calling viewCart after a successful API response.
   *
   * Checks if the provided response is a successful response using
   * isSuccessResponse, then calls cartContainer.viewCart while passing
   * the loyaltyPointShow parameter through.
   */
  handleViewCart = async (response, loyaltyPointShow) => {
    if (this.isSuccessResponse(response)) {
      await cartContainer.viewCart(loyaltyPointShow)
    }
  }

  /**
   * Debounces calling the viewCart method on the cartContainer
   * to avoid too frequent calls.
   *
   * Uses lodash debounce to rate limit calls to viewCart.
   */
  debounceViewCart = debounce(
    () => cartContainer.viewCart(false, false, false, true),
    900
  )

  /**
   * Checks cart response and disables payment continue
   */
  checkAndDisablePaymentContinueBtn = () => {
    this.isToDisablePaymentContinueBtn =
      cartContainer?.cartResponse?.paymentValue?.totalAmountUnpaid !== 0
        ? false
        : true
  }
  /**
   * Updates the shipping method for the cart or a specific cart item.
   *
   * @param {string} methodName - The ID of the shipping method to select.
   * @param {string} [cartItemId] - Optional cart item ID to update shipping for.
   * @param {Object} [recipientDetails] - Optional recipient details for BOPIS pickup.
   * @param {string} [recipientDetails.recipientName] - Name of the recipient.
   * @param {string} [recipientDetails.phoneCountryCode] - Country code for phone.
   * @param {string} [recipientDetails.phoneNumber] - Phone number of recipient.
   * @returns {Promise} The API response.
   */
  updateShippingMethod = async (
    methodName,
    cartItemId,
    recipientDetails = {}
  ) => {
    const pathParams = cartItemId ? `items/${cartItemId}` : ''
    const availableMethods =
      cartContainer?.cartResponse?.deliveryDetails?.methods || []
    const isBOPIS = availableMethods.find(method => method?.id === methodName)
      ?.properties?.BOPIS
    const deliveryType = isBOPIS
      ? SHIPPING_TYPE.STORE_PICKUP_METHODS
      : SHIPPING_TYPE.PHYSICAL
    const loadParams = {
      endPointName: 'updateBagAttributes',
      pathParams: pathParams,
      postData: {
        deliveryDetails: {
          methods: [
            {
              id: methodName,
              isTaxIncluded: true,
              isSelected: true,
            },
          ],
          deliveryType: deliveryType,
        },
      },
    }
    const response = await this.fetchResponse(loadParams)
    await this.updateCartStorePickUpProperty(!!isBOPIS, recipientDetails)
    const isExpressGpay =
      convertToBoolean(APPConfig.getAppConfig?.()?.enableExpressGooglePay) ||
      isExpressCheckout() ||
      false
    isExpressGpay
      ? await cartContainer.viewCartForTax()
      : await cartContainer.viewCart()
    return response
  }
  /**
   * Sends a new PATCH call to update cart properties with the isStorePickUp flag.
   * Also patches recipient details if BOPIS is selected and recipient info is provided.
   *
   * @param {boolean} isStorePickUp - true when BOPIS pickup is selected, false otherwise.
   * @param {Object} [recipientDetails] - Optional recipient details object.
   * @param {string} [recipientDetails.recipientName] - Name of the recipient.
   * @param {string} [recipientDetails.phoneCountryCode] - Country code for phone.
   * @param {string} [recipientDetails.phoneNumber] - Phone number of recipient.
   * @returns {Promise} The API response.
   */
  updateCartStorePickUpProperty = async (isStorePickUp, recipientDetails) => {
    const properties = {
      isStorePickUp: isStorePickUp,
    }

    // Add recipient details if BOPIS and recipient info is provided
    if (isStorePickUp && recipientDetails?.recipientName) {
      const { recipientName, phoneCountryCode, phoneNumber } = recipientDetails

      // Parse phone number to get proper international format
      let recipientPhone = ''
      try {
        const phoneObj = parsePhoneNumber(phoneNumber, phoneCountryCode)
        recipientPhone = phoneObj?.number || phoneNumber || ''
      } catch (e) {
        // If parsing fails, use the raw phone number
        recipientPhone = phoneNumber || ''
        console.error('Error parsing recipient phone number:', e)
      }

      properties.recipientName = recipientName
      properties.recipientPhone = recipientPhone
    } else {
      properties.recipientName = ''
      properties.recipientPhone = ''
    }

    const loadParams = {
      endPointName: 'updateBagAttributes',
      pathParams: '',
      postData: {
        properties: properties,
      },
    }
    return await this.fetchResponse(loadParams)
  }

  updateCheckoutInstallmentFrequency = frequency => {
    this.checkoutInstallmentFrequency = frequency
  }
  /**
   * Fetches pickup locations for a given country code.
   *
   * @param {string} countryCode - The country code to fetch pickup locations for.
   * @returns {Promise} Promise resolving to the API response containing pickup locations.
   */
  getPickUpLocations = async countryCode => {
    const loadParams = {
      endPointName: 'getPickUpLocations',
      pathParams: countryCode,
    }

    const response = await this.fetchResponse(loadParams)
    return response
  }

  /**
   * Sets the communication preference for zero checkout.
   *
   * Gets the address from the cart response delivery details.
   * Calls setCommunicationPreference() with the address as input.
   *
   * @returns {Promise} The result of calling setCommunicationPreference().
   */
  setCommunicationPreferenceForZeroCheckout = async () => {
    const communicationPreferenceData =
      cartContainer?.cartResponse?.deliveryDetails?.address || {}
    return await this.setCommunicationPreference(communicationPreferenceData)
  }
  /**
   * Checks if this is a zero checkout order.
   *
   * Returns true if zero checkout is enabled, no coupons or loyalty credits have been applied,
   * and the unpaid order total is 0.
   */
  isZeroCheckout = () => {
    return (
      storeContainer.getEnableZeroCheckout() &&
      !this.isCouponPaid &&
      !this.isLoyaltyPaid &&
      cartContainer?.cartResponse?.paymentValue?.bagValue === 0
    )
  }

  /**
   * ExpressCheckout-specific method: Checks if payment should be hidden.
   * Returns true when the total amount to pay is $0 after promotions/storecredit/loyalty,
   * but NOT when payment methods (like ChileWebpay) are selected.
   */
  shouldHidePaymentForExpress = () => {
    const payments = cartContainer?.cartResponse?.payments || []
    const hasNonZeroPaymentMethods = payments.some(
      payment => !['LOYALTY', 'STORECREDIT', 'COUPON'].includes(payment?.type)
    )

    if (hasNonZeroPaymentMethods) {
      return false
    }
    return (
      storeContainer.getEnableZeroCheckout() &&
      (cartContainer?.cartResponse?.paymentValue?.totalAmountUnpaid === 0 ||
        cartContainer?.cartResponse?.paymentValue?.bagValue === 0)
    )
  }
  /**
   * Checks if the order is fully paid by a coupon.
   *
   * Returns true if zero checkout is enabled, a coupon has been applied,
   * the unpaid order total is 0, and no loyalty credits or store credits have been applied.
   */
  isCouponFullPayment = () => {
    return (
      storeContainer.getEnableZeroCheckout() &&
      this.isCouponPaid &&
      cartContainer?.cartResponse?.paymentValue?.totalAmountUnpaid === 0 &&
      !this.isLoyaltyPaid &&
      !this.isStoreCreditsPaid
    )
  }
  /**
   * Checks if the order is fully paid by loyalty credits or a coupon.
   *
   * Returns true if zero checkout is enabled, loyalty credits or a coupon has been applied,
   * the unpaid order total is 0, and no store credits have been applied.
   */
  isLoyaltyOrCouponFullPayment = () => {
    return (
      storeContainer.getEnableZeroCheckout() &&
      (this.isCouponPaid || this.isLoyaltyPaid) &&
      cartContainer?.cartResponse?.paymentValue?.totalAmountUnpaid === 0 &&
      !this.isStoreCreditsPaid
    )
  }
  /**
   * Checks if the order is fully paid by loyalty credits, a coupon, or store credits.
   *
   * Returns true if zero checkout is enabled, loyalty credits, a coupon, or store credits have been applied,
   * the unpaid order total is 0.
   */
  isLoyaltyOrCouponOrStoreCreditsFullPayment = () => {
    return (
      storeContainer.getEnableZeroCheckout() &&
      (this.isCouponPaid || this.isLoyaltyPaid || this.isStoreCreditsPaid) &&
      cartContainer?.cartResponse?.paymentValue?.totalAmountUnpaid === 0
    )
  }
  /**
   * Checks if the order total value is 0 when zero checkout is disabled.
   *
   * Returns true if zero checkout is disabled and the unpaid order total is 0.
   * Returns false if zero checkout is enabled.
   */
  isZeroTotValWithDisableZeroCheckout = () => {
    return storeContainer.getEnableZeroCheckout()
      ? false
      : cartContainer?.cartResponse?.paymentValue?.bagValue === 0
  }
  /**
   * Sets the communication preference for the checkout.
   *
   * Updates the checkout with the provided communication preference form data.
   * Fetches profile data to populate some of the preference fields if not provided.
   * Validates required fields like email and phone.
   * Calls API to update the checkout bag attributes.
   * Handles success and error response from API update.
   */
  setCommunicationPreference = async formData => {
    // if (!formData) {
    //   formData = shippingAddress
    // }
    overlayState.showLoader()
    const profileData = customerContainer.profileResponse || {}
    const updatedShippingEmail =
      cartContainer?.cartResponse?.deliveryDetails?.address?.email || ''
    const updatedShippingPhone =
      cartContainer?.cartResponse?.deliveryDetails?.address?.phone || ''
    const lastName = isB2BAccount() === true ? '' : formData?.lastName
    let contactMethodText = ''

    formData?.email === null
      ? (contactMethodText = 'TEXT')
      : (contactMethodText = 'EMAIL')
    const loadParams = {
      endPointName: 'updateBagAttributes',
      postData: {
        communicationPreference: {
          //CX15-7890 - as per BA comments we set communicationPreference data from profiledata
          firstName: profileData?.firstName || formData?.firstName || '',
          lastName: profileData?.lastName || formData?.lastName || '',
          email: isFeatureEnabled('sendShippingEmailAndPhoneToCommunicationAPI')
            ? updatedShippingEmail
            : profileData?.email || formData?.email || '',
          phone: isFeatureEnabled('sendShippingEmailAndPhoneToCommunicationAPI')
            ? updatedShippingPhone
            : profileData?.phoneNumber || formData?.phone || '',
          zipCode: formData?.zip || '',
          preferredContactMethod: contactMethodText,
        },
      },
    }

    const errorMessage = {
      phone: i18nTranslate(
        'addressBook.invalidPhone',
        'Please enter contact number'
      ),
      email: i18nTranslate('validation.emailErrorText', 'Please enter email'),
    }

    const errorResponseMessage = {
      code: '',
      message: '',
      status: 'failure',
    }
    let isValidData = true
    let isOptionalPhone = isToHaveOptionalPhoneSchema('checkout') || false
    if (
      !loadParams?.postData?.communicationPreference?.phone &&
      !loadParams?.postData?.communicationPreference?.email
    ) {
      if (!isOptionalPhone) {
        errorResponseMessage.message = errorMessage.phone
      } else {
        errorResponseMessage.message = errorMessage.mail
      }
      isValidData = false
    } else {
      isValidData = true
    }

    if (!isValidData) {
      return Promise.resolve(errorResponseMessage)
    }

    const response = await this.fetchResponse(loadParams)
    if (this.isSuccessResponse(response)) {
      const isExpressGpay =
        convertToBoolean(APPConfig.getAppConfig?.()?.enableExpressGooglePay) ||
        isExpressCheckout() ||
        false
      isExpressGpay
        ? await cartContainer.viewCartForTax()
        : await cartContainer.viewCart()
    } else {
      trackErrorInInstana({
        errorReport: 'Fn setCommunicationPreference API',
        errorData: response,
      })
    }
    overlayState.hideLoader()
    return response
  }

  /**
   * Whether the address being patched onto the cart should also be saved to
   * the profile. Only for a signed-in shopper, and only when it is not one of
   * their saved addresses already (an address removed from the address book is
   * re-added, NGE1-4470).
   *
   * `addressLists` is only filled by `handleAddressExpressCheckout`; when that
   * express default-address step does not run (no default address, default too
   * long, PayPal, accordion already clicked ...) it stays null and every saved
   * address picked from the list was re-added on Continue, piling up duplicate
   * copies on the profile. Look at the address containers the list renders
   * from as well, and when no list has been loaded at all treat a
   * `profileAddressId` (only ever set from a saved address) as proof the
   * address is already on the profile.
   *
   * @param {Object} formData - The address form data
   * @returns {boolean} true if address should be added to profile, false otherwise
   */
  addAddressToProfile = formData => {
    if (!customerContainer.isRegisterUser) {
      return false
    }
    const savedAddressId = formData?.profileAddressId || formData?.addressId
    if (!savedAddressId) {
      return true
    }
    const loadedLists = [
      this.addressLists,
      addressContainer?.addressData,
      accountsAddressContainer?.addressData,
    ].filter(list => Array.isArray(list))
    if (!loadedLists.length) {
      return !formData?.profileAddressId
    }
    const addressMatchesInList = loadedLists
      .flat()
      .some(
        addr => addr?.addressId == savedAddressId || addr?.id == savedAddressId
      )
    return !addressMatchesInList
  }

  /**
   * Sets the shipping address for the cart or a specific cart item.
   *
   * @param {Object} formData - The address form data object.
   * @param {string} [cartItemId] - The ID of the cart item to set address for.
   * @param {boolean} [isItemLevelShipping=false] - Whether this is item-level shipping.
   * @returns {Promise} The API response.
   */
  setShippingAddress = async (
    formData,
    cartItemId,
    isItemLevelShipping = false
  ) => {
    const enabledGuestForWeb = isGuestCheckoutEnabledForWeb()
    if (!formData) {
      formData = shippingAddress
    }
    const {
      addressUserName = '',
      firstName = '',
      deliveryInstruction = '',
      shippingInstructions = '',
      addressLine2 = '',
      ...remainingProps
    } = formData

    const name =
      addressUserName !== '' && addressUserName !== undefined
        ? addressUserName
        : firstName
    const pathParams = cartItemId ? `items/${cartItemId}` : ''
    const shippingAddressPostData = {
      deliveryDetails: {
        deliveryType: SHIPPING_TYPE.PHYSICAL,
        address: {
          firstName: name,
          addressLine2: addressLine2,
          /* https://nuskin.atlassian.net/browse/NGE2-1004
           * Addressline2 is sent as empty string instead of null
           * to avoid billing address validation issues in PAC region
           */
          deliveryInstruction:
            deliveryInstruction || shippingInstructions || '',
          ...remainingProps,
          canReceiveSMS: false,
          profileAddressId:
            formData.profileAddressId || formData.addressId || null,
          isDefault: formData?.setDefaultAddress || false,
          validation: [
            {
              type: 'PHYSICAL',
              validated: true,
              overridden: true,
            },
          ],
          options: {
            addAddressToProfile: this.addAddressToProfile(formData),
          },
        },
      },
    }

    const loadParams = {
      endPointName: 'updateBagAttributes',
      postData: shippingAddressPostData,
      pathParams: pathParams,
    }
    const response = await this.fetchResponse(loadParams)
    const enableNewGuestModal =
      convertToBoolean(APPConfig.getAppConfig()?.enableNewGuestModal) || false
    if (enabledGuestForWeb && !checkMysiteOrPersonalOffer()) {
      await this.updateCartProperties({ cartItemId, GST: formData?.GSTIN })
      if (!customerContainer.isRegisterUser) {
        await this.updateGuestCustomerConsents(formData)
      }
    } else if (
      checkMysiteOrPersonalOffer() &&
      enableNewGuestModal &&
      !customerContainer.isRegisterUser
    ) {
      const { email = '', firstName = '', lastName = '' } = formData || {}
      const signupOrigin = getGuestSignupOrigin()

      const postData = {
        firstName,
        lastName,
        email: email?.toLowerCase(),
        customProperties: {
          personType: 'PRIMARY',
          signupOrigin,
        },
      }
      await cartContainer?.updateGuestCustomer(postData)
    }
    await this.updateExpressCartSponsorProperty()
    if (isItemLevelShipping) {
      this.debounceViewCart()
    } else {
      await cartContainer.viewCart(false, false, false, true)
    }
    if (
      this.isSuccessResponse(response) &&
      !customerContainer.isRegisterUser &&
      !isExpressCheckout()
    ) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'guest_checkout_consent',
          vip_status: formData?.signupBrandRepresentative
            ? 'opt-in'
            : 'opt-out',
          email_status: formData?.emailOptIn ? 'opt-in' : 'opt-out',
          sms_status: formData?.smsOptIn ? 'opt-in' : 'opt-out',
        },
      })
    }
    return response
  }

  updateCartProperties = async options => {
    const { GST } = options || {}
    const { cartItemId } = options || {}
    const pathParams = cartItemId ? `items/${cartItemId}` : ''
    const utmInfo = getUTMInfo() || {}

    const { enableEQFastFollow = false } = APPConfig?.getAppConfig() || false
    const uttInfo = convertToBoolean(enableEQFastFollow)
      ? getUTTInfo() || {}
      : {}

    const sponsorId = accountsContainer?.getUserTypeSponsorId()
    let guestCheckoutPostData = {
      properties: {
        source: getGuestSignupOrigin(),
        sponsorId: sponsorId,
        ...utmInfo,
        ...uttInfo,
      },
    }
    /** Support empty string for GSTIN removal */
    if (GST !== undefined) {
      guestCheckoutPostData.properties.GSTIN = GST
    }

    const loadParams = {
      endPointName: 'updateBagAttributes',
      pathParams: pathParams,
      postData: guestCheckoutPostData,
    }

    const response = await this.fetchResponse(loadParams)
    return response
  }

  updateGuestCustomerConsents = async (addressData = {}) => {
    const { consents = [] } = await customerContainer.signupConsents()
    const enableNewGuestModal =
      convertToBoolean(APPConfig.getAppConfig()?.enableNewGuestModal) || false
    let consentTitle = []
    let activeConsent = []
    if (Array.isArray(consents) && consents.length) {
      const vipCheckboxStatus = getSessionStorage('vipCheckboxStatus') || false
      consentTitle.push(
        vipCheckboxStatus ? 'privacy_noprivacy~0' : 'privacy_contactinfo~1'
      )

      const { enableEQFastFollow = false } = APPConfig?.getAppConfig() || false
      const checkEQFastFollow = convertToBoolean(enableEQFastFollow)

      if (checkEQFastFollow && !customerContainer.isRegisterUser) {
        const emailOptInStatus = getSessionStorage('emailOptInStatus') || false
        consentTitle.push(
          emailOptInStatus
            ? 'promotional_optIn_email'
            : 'promotional_optOut_email'
        )
        const smsOptInStatus = getSessionStorage('smsOptInStatus') || false
        consentTitle.push(
          smsOptInStatus ? 'promotional_optIn_SMS' : 'promotional_optOut_SMS'
        )
      }

      activeConsent = consents?.filter(consent =>
        consentTitle.includes(consent.title)
      )
    }

    const ipAddress = await getBrowserIpAddress()
    const browserType = getBrowserType() || {}
    const {
      email = '',
      firstName = '',
      lastName = '',
    } = enableNewGuestModal ? addressData : customerContainer?.profileResponse

    let consentsArray = []
    activeConsent?.map(consent => {
      const { id = '', title = '' } = consent || {}
      consentsArray.push({
        consentId: id,
        userId: customerContainer.profileResponse?.id || '',
        browser: browserType?.name,
        device: application.deviceType,
        geoLocation:
          storeContainer.currentRegion ||
          getLocalStorage('currentRegion') ||
          '',
        ipAddress: ipAddress,
        createdTimestamp: new Date(),
        updatedTimestamp: new Date(),
        title: title,
      })
    })

    //const sponsorId = accountsContainer?.getUserTypeSponsorId()
    const consentsPostData = {
      email: email?.toLowerCase(),
      firstName: firstName || '',
      lastName: lastName || '',
      consents: consentsArray, //Commented SponsorId code for PUR-1124
      // customProperties: {
      //   sponsorId: sponsorId,
      // },
    }
    if (enableNewGuestModal) {
      const signupOrigin = getGuestSignupOrigin()
      consentsPostData.customProperties = {
        personType: 'PRIMARY',
        signupOrigin,
      }
    }
    await cartContainer?.updateGuestCustomer(consentsPostData)
  }

  /**
   * Sets the pickup location as address for delivery details
   *
   * @param {Object} address - Address from location api
   */
  setPickupLocationAsDefaultForLiveEvent = async (address = {}) => {
    const {
      address1 = '',
      address2 = '',
      address3 = '',
      city = '',
      state = '',
      postalCode = '',
      country = '',
    } = address
    const { firstName = '', lastName = '' } = customerContainer?.profileResponse
    const defaultAddressPostData = {
      deliveryDetails: {
        deliveryType: SHIPPING_TYPE.STORE_PICKUP,
        address: {
          firstName: firstName,
          lastName: lastName,
          addressLine1: address1,
          addressLine2: address2,
          addressLine3: address3,
          city: city,
          state: state,
          country: country,
          email: customerContainer?.profileResponse?.email || '',
          phone: customerContainer?.profileResponse?.phoneNumber || '',
          zip: postalCode,
          deliveryInstruction: '',
          canReceiveSMS: false,
          profileAddressId: null,
          isDefault: true,
          validation: [
            {
              type: 'PHYSICAL',
              validated: true,
              overridden: true,
            },
          ],
          options: {
            addAddressToProfile: false,
          },
        },
      },
    }
    const loadParams = {
      endPointName: 'updateBagAttributes',
      postData: defaultAddressPostData,
    }
    const response = await this.fetchResponse(loadParams)
    await cartContainer.viewCart()
  }
  /**
   * Checks if there is a default payment in the customer's saved payments.
   * Sets this.defaultFlag to true if no default payment is found.
   */
  getIsDefault = () => {
    this.defaultFlag = !customerContainer?.paymentResponse?.payments?.find(
      (cards, index) => cards.isDefault
    )
  }
  /**
   * Retrieves a PayPal token by calling the getPayPalToken endpoint.
   *
   * Creates a loadParams object with the getPayPalToken endpoint name.
   * Calls the fetchResponse method with loadParams.
   * Returns the response from fetchResponse.
   */
  getPayPalToken = async () => {
    const loadParams = {
      endPointName: 'getPayPalToken',
    }

    const response = await this.fetchResponse(loadParams)
    return response
  }
  /**
   * Retrieves a Payment token by calling the getBrainTreePaymentToken endpoint.
   *
   * Creates a loadParams object with the getBrainTreePaymentToken endpoint name and
   * a query parameter specifying the payment type.
   * Calls the fetchResponse method with loadParams.
   * Logs the response and returns it.
   */
  getBrainTreePaymentToken = async (paymentType = '') => {
    const loadParams = {
      endPointName: 'getBrainTreePaymentToken',
      queryParams: {
        paymentType,
      },
    }
    const response = await this.fetchResponse(loadParams)
    return response
  }
  /**
   * Validates the original billing address passed in reqParams, calls originalAddressApiCall
   * to add it, and if successful calls addPaymentsToCart.
   *
   * @param {Object} reqParams - Request parameters object containing billingAddress
   * @returns {Promise} - Promise resolving to response from addPaymentsToCart or address API
   */
  validateOriginalAddress = async reqParams => {
    let addressAddResponse = {}
    let response = await addressContainer?.originalAddressApiCall(
      reqParams?.billingAddress
    )
    if (this.isSuccessResponse(response)) {
      addressAddResponse = this.addPaymentsToCart(reqParams)
      return addressAddResponse
    } else {
      if (response.message === 'input.validation.failed') {
        response.message = alertMessageKeys(
          'Please correct the address to proceed.'
        )
        toastState.setToastMessage(response.message, false)
      } else {
        toastState.setToastMessage(
          i18nTranslate(
            'address.addAddressFailure',
            'Sorry, we are unable to add your address. Please try again.'
          ),
          false
        )
      }
      return response
    }
  }
  /**
   * Adds a payment to the cart by calling the addPaymentToCart API endpoint.
   *
   * Constructs the payment data and options to send to the API. Gets cart and user info from containers.
   * Handles saving payment info to user's profile if requested.
   * Sends tag manager event on success.
   * Handles error cases and validation failures.
   */
  addPaymentsToCart = async paymentData => {
    const isIstallmentEnabled = convertToBoolean(
      APPConfig.getAppConfig()?.enableCheckoutInstallment
    )
    const isBillingAddressRequired = enableBillingAddressRequired()
    const bagValue = Math.abs(
      cartContainer?.cartResponse?.paymentValue?.totalAmountUnpaid || ''
    )
    if (customerContainer.isRegisterUser) {
      await this.getIsDefault()
    }
    const cardDetails = {}
    const { isFromSavedAddress } = paymentData
    const isSavedSepaPayment =
      isFromSavedAddress && isTwikeyPaymentName(paymentData?.name)
    const gpsCreditCardOptions = this.globalPaymentResponse?.CREDITCARD || []
    const isSavedPlainCvvGPSPayment =
      isFromSavedAddress &&
      isExternalGPSCreditCardPaymentName(
        paymentData?.name,
        gpsCreditCardOptions
      )
    const getSavedPlainCvvGPSCardCvvFromInput = () => {
      if (!IS_BROWSER || !paymentData?.id) {
        return ''
      }
      const inputElement = document.getElementById(
        `savedCardCvvInput${paymentData.id}`
      )
      const cvv = (inputElement?.value || '').replace(/\D/g, '')
      if (!cvv) {
        return ''
      }
      const provider = (
        paymentData?.accountInfo?.provider ||
        paymentData?.accountInfo?.type ||
        ''
      )
        .toString()
        .toUpperCase()
      const isAmexCard =
        provider === 'AMEX' ||
        provider === 'AMERICAN EXPRESS' ||
        provider === 'AMERICANEXPRESS'
      const expectedLength = isAmexCard ? 4 : 3
      return cvv.length === expectedLength ? cvv : ''
    }

    let savedPlainCvvGPSCardCvv =
      paymentData?.cardCVV ||
      paymentData?.cvv ||
      paymentData?.accountInfo?.cvv ||
      paymentData?.accountInfo?.cardCVV ||
      paymentData?.properties?.cvv ||
      paymentData?.tokenExData?.cvv ||
      paymentData?.tokenExCvvData?.cvv ||
      savedCardsContainer?.tokenExCvvData?.cvv ||
      ''
    if (isSavedPlainCvvGPSPayment && !savedPlainCvvGPSCardCvv) {
      savedPlainCvvGPSCardCvv = getSavedPlainCvvGPSCardCvvFromInput()
    }
    if (isFromSavedAddress) {
      if (isSavedSepaPayment) {
        savedCardsContainer.tokenCvvValidData = { isValid: true }
      } else if (isSavedPlainCvvGPSPayment) {
        if (!savedPlainCvvGPSCardCvv) {
          checkoutContainer.isPaymentApiInProgress = false
          return false
        }

        savedCardsContainer.tokenCvvValidData = { isValid: true }
        savedCardsContainer.tokenExCvvData = {
          cvvIncluded: false,
          cvv: savedPlainCvvGPSCardCvv,
        }
      } else {
        const { isValid } = savedCardsContainer?.tokenCvvValidData || {}
        if (!isValid) {
          checkoutContainer.isPaymentApiInProgress = false
          return false
        }
      }
    }

    if (paymentData.isPONumber) {
      cardDetails.properties = { purchaseOrder: paymentData.PONumber }
    } else {
      cardDetails.accountInfo = paymentData.accountInfo
      if (paymentData.isFromSavedAddress || paymentData.isRewardPoints) {
        cardDetails.paymentItems = [{ paymentRefId: paymentData?.id }]
        cardDetails.accountInfo = isSavedSepaPayment
          ? {}
          : {
              cvv: isSavedPlainCvvGPSPayment
                ? savedPlainCvvGPSCardCvv
                : paymentData.cardCVV,
            }
      } else if (isPaymetricEnabled()) {
        const pmData = paymetricContainer.paymetricFormData || {}
        const pmLastFour = pmData.lastFour || ''
        const pmCardProvider =
          paymetricContainer.getCardProviderFromTokenData(pmData)
        const pmCardType = normalizePaymetricCardType(pmCardProvider)

        // Enforce CVV rules before payment API call.
        const cvvValidation = paymetricContainer.validatePaymetricCvv()
        if (!cvvValidation.isValid) {
          checkoutContainer.isPaymentApiInProgress = false
          toastState.setToastMessage(cvvValidation.errorMessage, false)
          return false
        }

        cardDetails.accountInfo = {
          ...cardDetails.accountInfo,
          cardNumber: pmLastFour,
          type: pmCardType,
          cardCVV: pmData.cvv || '',
          provider: pmCardProvider,
        }
      }
    }

    const paymentProvider = (
      cardDetails?.accountInfo?.provider ||
      cardDetails?.accountInfo?.type ||
      paymentData?.accountInfo?.provider ||
      paymentData?.accountInfo?.type ||
      ''
    )
      .toString()
      .toUpperCase()
    const restrictedCardType = getRestrictedCardType(paymentProvider)
    if (restrictedCardType) {
      checkoutContainer.isPaymentApiInProgress = false
      toastState.setToastMessage(
        i18nTranslate(restrictedCardType.key, restrictedCardType.fallback),
        false
      )
      return false
    }

    const cardType = paymentData.cardType
      ? paymentData.cardType
      : paymentData.type
        ? paymentData.type
        : 'CREDITCARD'

    const valueType =
      cardType.toLowerCase() === 'loyalty' ? 'NONCASH' : 'CURRENCY'
    const { firstName, lastName, addressUserName, ...remainingProps } =
      paymentData.billingAddress || {}
    const addPaymentToProfile =
      paymentData.billingAddress?.option?.addPaymentToProfile || false
    const userFirstName = addressUserName || firstName
    const userLastName = lastName || userFirstName
    let savedAddressPaymentDataProperties
    if (isSavedSepaPayment) {
      const sepaPaymentOptionType = this.getGpsPaymentConfigType(
        SEPA,
        this.globalPaymentResponse
      )
      // The GPS option carries the market's content-managed label
      // ('SEPA Direct Debit'); the generic name is only a fallback.
      const sepaGpsDisplayName = this.getGpsPaymentConfigDisplayName(
        SEPA,
        this.globalPaymentResponse
      )
      savedAddressPaymentDataProperties = {
        displayName: sepaGpsDisplayName || 'SEPA',
        ...(sepaPaymentOptionType && {
          paymentOptionType: sepaPaymentOptionType,
        }),
      }
    } else if (isSavedPlainCvvGPSPayment) {
      savedAddressPaymentDataProperties = {
        cvvIncluded: !!savedPlainCvvGPSCardCvv,
        cvv: savedPlainCvvGPSCardCvv,
      }
    } else {
      savedAddressPaymentDataProperties = {
        ...savedCardsContainer.tokenExCvvData,
        ...paymentData?.tokenExData,
      }
    }
    // Resolve the exact processor for this payment so a mixed response cannot
    // route another processor's card through the GPS payload.
    const configuredGPSCreditCardProcessorName =
      paymentData?.name ?? APPConfig.getAppConfig()?.gpsSavedCardProcessorName
    const selectedGPSCreditCardOption = getGpsRoutedCreditCardOption(
      gpsCreditCardOptions,
      configuredGPSCreditCardProcessorName
    )

    const isGPSPayment = Boolean(selectedGPSCreditCardOption)
    // External GPS processors keep token; Paymetric CREDITCARD payloads use paymetricToken.
    const processorForPayment =
      selectedGPSCreditCardOption ??
      getConfiguredGPSCreditCardOption(
        gpsCreditCardOptions,
        configuredGPSCreditCardProcessorName
      ) ??
      (isPaymetricEnabled()
        ? gpsCreditCardOptions.find(isPaymetricGPSCreditCardOption)
        : undefined) ??
      this.getValidGPSCreditCardProcessor()
    const isPaymetric3DS = isPaymetricGPSCreditCardOption(processorForPayment)
    const shouldUsePaymetricToken =
      isPaymetric3DS ||
      (!isGPSPayment && cardType.toLowerCase() === PAYMENT_TYPE.CREDITCARD)
    const paymentDataProperties = paymentData.isFromSavedAddress
      ? savedAddressPaymentDataProperties
      : isPaymetricEnabled()
        ? (() => {
            const pmData = paymetricContainer.paymetricFormData || {}
            const tokenProperty = shouldUsePaymetricToken
              ? { paymetricToken: pmData.token }
              : { token: pmData.token }
            return {
              ...(pmData.firstSix && { firstSix: pmData.firstSix }),
              ...(pmData.lastFour && { lastFour: pmData.lastFour }),
              ...(pmData.kHash && { kHash: pmData.kHash }),
              ...(pmData.token && tokenProperty),
              ...(pmData.referenceNumber && {
                referenceNumber: pmData.referenceNumber,
              }),
              ...(pmData.tokenHMAC && { tokenHMAC: pmData.tokenHMAC }),
              ...(pmData.cvv && { cvv: pmData.cvv }),
              cvvIncluded: pmData.cvvIncluded ?? false,
            }
          })()
        : { ...tokenExContainer.tokenExFormData }
    if (isIstallmentEnabled && this.checkoutInstallmentFrequency !== '') {
      paymentDataProperties.installment = this.checkoutInstallmentFrequency
    }
    // Surfaces the configured processor type (e.g. PayU/Braintree) for GPS credit card payments.
    if (isGPSPayment && selectedGPSCreditCardOption?.type) {
      paymentDataProperties.paymentOptionType = selectedGPSCreditCardOption.type
    }

    const effectiveCartType = this.getEffectiveCartType()

    // A saved SEPA record carries its own `type`, but the contract is driven by
    // the GPS option config: an external processor takes 'GPS', an internal one
    // takes the option id ('SEPA'). Same resolution as the new-entry path.
    const savedSepaPaymentType = isSavedSepaPayment
      ? this.resolveGpsOptionIdentity(SEPA).type
      : ''
    const paymentTypeForRequest =
      savedSepaPaymentType || (isGPSPayment ? 'GPS' : cardType)
    const isCreditCard =
      processorForPayment?.type?.toLowerCase() === GPS_CCARD_TYPE
    const paymentNameForRequest = isCreditCard
      ? 'CREDITCARD'
      : (paymentData?.name ?? getGpsOptionId(processorForPayment))

    const loadParams = {
      endPointName: 'addPaymentToCart',
      cartType: effectiveCartType,
      postData: [
        {
          billingAddress: {
            firstName: userFirstName,
            lastName: userLastName,
            ...remainingProps,
          },
          ...cardDetails,
          type: paymentTypeForRequest,
          ...((isGPSPayment || isCreditCard) &&
            paymentNameForRequest && {
              name: paymentNameForRequest,
            }),
          ...(isSavedSepaPayment && {
            // Saved records are named 'Twikey'/'SEPA'; the API expects the GPS
            // option identifier, same as the new-entry path.
            name: this.getSepaPaymentName(),
          }),
          valueType,
          value: bagValue,
          isDefault: this.defaultFlag
            ? this.defaultFlag
            : paymentData?.isDefault || false,
          amount: bagValue,
          option: {
            addPaymentToProfile: addPaymentToProfile,
            useDefaultPayment: false,
            setAsDefaultPaymentInProfile: false,
          },
          properties: paymentDataProperties,
        },
      ],
    }
    delete loadParams.postData[0].properties.cardType

    const shouldSkipBillingAddress =
      isSavedPlainCvvGPSPayment || (!isBillingAddressRequired && !isGPSPayment)
    if (shouldSkipBillingAddress) {
      loadParams.postData[0].billingAddress = null
    }
    const response = await this.fetchResponse(loadParams)

    /**
     * @info
     * GTM Datalayer -  Add payment during checkout
     */
    const { accountInfo, isDefault } = loadParams?.postData?.[0] || []
    TagManager.dataLayer({
      dataLayer: {
        event: 'paymentAddedComplete',
        ...getCheckoutGTMPageData({
          pageTitle: 'Payment Details',
        }),
        firstName: accountInfo?.name || '',
        lastName: accountInfo?.lastName || '',
        cardType: accountInfo?.type || '',
        isDefault: isDefault || '',
        platform: 'equinox',
      },
    })

    if (response?.code == 'EOPYCRT0001') {
      toastState.setToastMessage(
        i18nTranslate(
          'payment.addedPaymentFail',
          'Card type is not supported in current Market/Channel'
        ),
        false
      )
      trackErrorInInstana({
        errorReport: 'Payment card is not supported in current Market/channel',
        errorData: {
          payload: loadParams,
          apiResponse: response,
        },
      })
    } else if (response?.message?.toLowerCase() == 'validation error') {
      trackErrorInInstana({
        errorReport: 'Payment validation error',
        errorData: {
          payload: loadParams,
          apiResponse: response,
        },
      })
    }

    // await cartContainer.viewCart()
    if (!isExpressCheckout()) {
      if (!this.isSuccessResponse(response)) {
        await this.deletePayment()
      } else {
        this.checkAndDisablePaymentContinueBtn()
      }
    }
    return response
  }

  /**
   * Adds a store credit payment to the cart.
   *
   * @param {number} storeCreditValue - The amount of store credit to apply as payment.
   * @returns {Promise} Response from adding payment to cart API call.
   */
  addStoreCreditPayment = async storeCreditValue => {
    const loadParams = {
      endPointName: 'addPaymentToCart',
      postData: [
        {
          type: 'STORECREDIT',
          valueType: 'STORECREDIT',
          value: storeCreditValue,
          amount: storeCreditValue,
          option: {
            addPaymentToProfile: true,
            useDefaultPayment: false,
            setAsDefaultPaymentInProfile: false,
          },
        },
      ],
    }
    const response = await this.fetchResponse(loadParams)
    return response
  }
  /**
   * Deletes a payment from the cart by ID.
   *
   * @param {string} paymentId - The ID of the payment to delete.
   * @returns {Promise} The response from the API call.
   */
  deleteCartPaymentWithID = async paymentId => {
    const effectiveCartType = this.getEffectiveCartType()

    const loadParams = {
      endPointName: 'deletePaymentsFromCart',
      pathParams: paymentId,
      cartType: effectiveCartType,
    }
    const response = await this.fetchResponse(loadParams)
    return response
  }

  /**
   * Deletes any existing store credit payment from the cart.
   *
   * Gets the current cart payments and finds any with the 'STORECREDIT' type.
   * If one exists, calls deleteCartPaymentWithID() to remove it.
   *
   * Shows success/failure toast messages based on response from delete call.
   *
   * Returns the API response from deleting the payment (or true if none existed).
   */
  deleteAllStoreCreditPayments = async () => {
    const existingPayments = cartContainer?.cartResponse?.payments || []
    const storeCreditPayment = existingPayments?.find(
      payment => payment?.type === 'STORECREDIT'
    )

    if (storeCreditPayment && storeCreditPayment.id) {
      const response = await checkoutContainer.deleteCartPaymentWithID(
        storeCreditPayment.id
      )
      if (checkoutContainer.isSuccessResponse(response)) {
        toastState.setToastMessage(
          i18nTranslate(
            'cart.storeCreditPurchaseSuccess',
            'Payment has been removed from store credit.'
          ),
          true
        )
      } else {
        toastState.setToastMessage(
          i18nTranslate(
            'cart.storeCreditPurchaseFailure',
            'Unable update payment preference, Please try again.'
          )
        )
      }
      return response
    }
    return true
  }

  /**
   * Deletes all existing credit card payments from the cart.
   *
   * Gets the current cart payments and loops through them, finding any with
   * 'CREDITCARD' or 'DEBITCARD' type. Calls deleteCartPaymentWithID() on each to remove it.
   *
   * After removing, calls viewCart() to refresh the cart data.
   *
   * Returns nothing.
   */
  deleteAllCreditCardPayments = async () => {
    const existingPayments = cartContainer?.cartResponse?.payments || []
    let isDeleteCallMade = false
    for (const payment of existingPayments) {
      if (payment?.type === 'CREDITCARD' || payment?.type === 'DEBITCARD') {
        const response = await checkoutContainer.deleteCartPaymentWithID(
          payment.id
        )
        isDeleteCallMade = true
      }
    }
    if (isDeleteCallMade) {
      await cartContainer.viewCart()
    }
  }

  /**
   * Checks the available store credit points for the current cart.
   *
   * Gets the cart payments and finds any 'STORECREDIT' payment.
   * Calculates the total unpaid amount.
   * Gets the current loyalty points.
   * Sets storeCreditInputFieldValue to the STORECREDIT amount, if it exists.
   * Otherwise sets to min of total unpaid amount or current points.
   */
  setStoreCreditInputFieldValue = () => {
    const payments = cartContainer?.cartResponse?.payments || []
    let storeCreditPayment = payments?.find(option => {
      return option?.type === 'STORECREDIT'
    })
    const totalAmountUnpaid =
      cartContainer?.cartResponse?.paymentValue?.totalAmountUnpaid || 0.0
    let currentPoints = loyaltyContainer.storeCreditPoints || 0
    this.storeCreditInputFieldValue = storeCreditPayment
      ? storeCreditPayment?.amount || 0
      : currentPoints > totalAmountUnpaid
        ? totalAmountUnpaid
        : currentPoints
  }

  /**
   * Loads the Braintree client library script if not already loaded.
   *
   * Checks if document contains element with ID 'braintreeClient'.
   * If not, creates a new <script> element, sets ID and src,
   * and appends to document body.
   */
  loadBraintreeClientScript = () => {
    if (IS_BROWSER && !document.getElementById('braintreeClient')) {
      const brainTreeClientScript =
        APPConfig.getAppConfig()?.brainTreeClientScript || ''
      const script = document.createElement('script')
      script.id = 'braintreeClient'
      script.src = brainTreeClientScript
      document.body.appendChild(script)
    }
  }

  /**
   * Loads the Braintree checkout library script if not already loaded.
   *
   * Checks if the browser document contains an element with ID 'braintreeCheckout'.
   * If not, it creates a new <script> element, sets the ID and src attributes,
   * and appends it to the document body.
   */
  loadBraintreeCheckoutScript = () => {
    if (IS_BROWSER && !document.getElementById('braintreeCheckout')) {
      const paypalClientId = APPConfig.getAppConfig()?.paypalClientScript || ''
      const script = document.createElement('script')
      script.id = 'braintreeCheckout'
      script.src = paypalClientId
      document.body.appendChild(script)
    }
  }

  /**
   * Loads the Braintree Venmo client library script if not already loaded.
   *
   * Checks if the browser document contains an element with ID 'braintreeVenmoClient'.
   * If not, it creates a new <script> element, sets the ID and src attributes,
   * and appends it to the document body.
   */
  loadBraintreeVenmoClientScript = () => {
    if (IS_BROWSER && !document.getElementById('braintreeVenmoClient')) {
      const braintreeClientScript =
        APPConfig.getAppConfig().brainTreeClientScript
      const script = document.createElement('script')
      script.id = 'braintreeVenmoClient'
      script.src = braintreeClientScript
      document.body.appendChild(script)
    } else {
      console.log('** Venmo Client Script not loaded')
    }
  }

  /**
   * Loads the Braintree Venmo data collector library script if not already loaded.
   *
   * Checks if the browser document contains an element with ID 'braintreeVenmoDataCollector'.
   * If not, it creates a new <script> element, sets the ID and src attributes,
   * and appends it to the document body.
   */
  loadBraintreeVenmoDataCollectorScript = () => {
    if (IS_BROWSER && !document.getElementById('braintreeVenmoDataCollector')) {
      const venmoDataCollectorScript =
        APPConfig.getAppConfig().venmoDataCollectorScript
      const script = document.createElement('script')
      script.id = 'braintreeVenmoDataCollector'
      script.src = venmoDataCollectorScript
      document.body.appendChild(script)
    } else {
      console.log('** Venmo Data Collector Script not loaded')
    }
  }

  /**
   * Loads the Braintree Venmo client library script if not already loaded.
   *
   * Checks if the browser document contains an element with ID 'braintreeVenmo'.
   * If not, it creates a new <script> element, sets the ID and src attributes,
   * and appends it to the document body.
   */
  loadBraintreeVenmoScript = () => {
    if (IS_BROWSER && !document.getElementById('braintreeVenmo')) {
      const venmoClientScript = APPConfig.getAppConfig().venmoClientScript
      const script = document.createElement('script')
      script.id = 'braintreeVenmo'
      script.src = venmoClientScript
      document.body.appendChild(script)
    } else {
      console.log('** Venmo Script not loaded')
    }
  }

  loadApplePayScripts = () => {
    if (IS_BROWSER && !document.getElementById('applepayInitJs')) {
      const applepayScript =
        APPConfig.getAppConfig?.()?.applepayInitScript || ''
      const script = document.createElement('script')
      script.id = 'applepayInitJs'
      script.src = applepayScript
      document.body.appendChild(script)
    } else {
      console.log('** Apple Pay Script is not loaded')
    }
  }

  /**
   * Email to use for a saved shipping address on checkout. A profile address
   * can legitimately carry no email: the Account Profile / Address Book flows
   * do not always store one, and `Address.getProfileAddress` blanks any address
   * on `blockedEmailList`. The manual Continue path
   * (`ShippingAccordion.handleAddressContinue`) has always fallen back to the
   * signed-in shopper's profile email; the saved-address card validation and
   * the express default-address patch did not, so such an address rendered
   * "Please enter email", its radio stayed unchecked/disabled and the cart was
   * patched with an empty email (MDIGI-16357). Same fallback here.
   *
   * @param {Object} address - profile / saved shipping address
   * @returns {string} address email, else the signed-in profile email, else ''
   */
  getShippingAddressEmail = address =>
    address?.email ||
    (customerContainer?.isRegisterUser
      ? customerContainer?.profileResponse?.email || ''
      : '')

  /**
   * NLXX config is lazy-loaded by whichever address component mounts first; the
   * express skip path and ExpressCheckout's load-time pick can run before any
   * has, when `enableNLXX` still reads false and the country filter would drop
   * valid cross-border addresses. `loadNLXXConfig` is cached per store, so
   * calling it here is free once loaded. (NGE1-3967)
   */
  ensureNLXXConfigLoaded = () => {
    if (
      !nlxxConfigContainer.nlxxConfigStoreId ||
      nlxxConfigContainer.nlxxConfigStoreId !== storeContainer.activeStoreId
    ) {
      nlxxConfigContainer.loadNLXXConfig()
    }
  }

  /**
   * The saved addresses express checkout may apply: shipping type (the API has
   * returned 'Shipping' as well as 'shipping', #TD-5284) and, unless NLXX
   * cross-border shipping is enabled, the store's home country only. Shared by
   * `handleAddressExpressCheckout` and ExpressCheckout's load-time pick so the
   * gate and the patch look at the same list.
   */
  filterSavedShippingAddresses = addresses => {
    this.ensureNLXXConfigLoaded()
    const defaultCountry =
      storeContainer.defaultShippingRegion === 'Canada'
        ? 'CA'
        : storeContainer.defaultShippingRegion
    const isNLXXEnabled = nlxxConfigContainer.enableNLXX
    return (addresses || []).filter(data => {
      const isShippingAddress = data?.type?.toLowerCase() === 'shipping'
      const isHomeMarket = data?.country === defaultCountry
      return isNLXXEnabled
        ? isShippingAddress
        : isShippingAddress && isHomeMarket
    })
  }

  /**
   * Gate the express default-address patch has always applied: a phone (unless
   * the market makes it optional) and the address-line length rule
   * (CX115-7746). Email is not required - `getShippingAddressEmail` fills it.
   */
  passesExpressAddressGate = address => {
    if (isEmpty(address)) {
      return false
    }
    const isOptionalPhone = isToHaveOptionalPhoneSchema('checkout') || false
    return Boolean(
      (address.phone || isOptionalPhone) &&
        !validateMaxLengthForAddressLine(address)
    )
  }

  /**
   * A non-default saved address express checkout may apply on the shopper's
   * behalf: the gate above plus the fields the saved-address card validates.
   */
  isUsableSavedAddress = address =>
    this.passesExpressAddressGate(address) &&
    Boolean(address.addressLine1 && address.firstName && address.city)

  /**
   * The saved address express checkout applies on load. The default address
   * when it passes the gate (unchanged behaviour); otherwise the address
   * already on the cart (a previous session) when it is still one of the saved
   * ones; otherwise the first usable saved address. Without the fallbacks a
   * shopper whose account has no default, or whose default fails the gate, saw
   * Shipping Method and Payment locked behind "...will be available once you
   * enter shipping address" with a saved address rendered as selected and
   * Submit disabled, until they clicked the address again.
   *
   * @param {Array} savedAddresses - shipping addresses for the market
   * @param {Object} [options]
   * @param {boolean} [options.gateDefault=false] - also require the default to
   *   pass the express gate (ExpressCheckout applies the gate itself before
   *   patching; the model keeps the default whenever one exists, as before)
   * @returns {Object|undefined} address to patch, or undefined
   */
  pickExpressDefaultAddress = (savedAddresses = [], options = {}) => {
    const { gateDefault = false } = options || {}
    const list = savedAddresses || []
    const defaultAddress = list.find(address => address?.isDefault)
    if (
      !isEmpty(defaultAddress) &&
      (!gateDefault || this.passesExpressAddressGate(defaultAddress))
    ) {
      return defaultAddress
    }
    const cartAddress = cartContainer?.cartResponse?.deliveryDetails?.address
    const cartSavedId = cartAddress?.profileAddressId || cartAddress?.addressId
    const cartMatch =
      cartSavedId &&
      list.find(
        address =>
          address?.addressId == cartSavedId || address?.id == cartSavedId
      )
    if (this.isUsableSavedAddress(cartMatch)) {
      return cartMatch
    }
    return list.find(address => this.isUsableSavedAddress(address))
  }

  /**
   * handleAddressPayPalCartCheckout
   *
   * Async function that handles setting the shipping address for PayPal checkout.
   *
   * Checks if this is a B2B user, and if so, gets the address list from the accountsAddressContainer.
   * Otherwise gets the address list from the customer's profile.
   *
   * Filters the addresses to only include the default shipping address in the store's default country.
   *
   * Sets the default shipping address via the checkoutContainer.
   *
   * Checks the response for any out of stock or backordered items, and if found,
   * displays a toast message and redirects to the cart page after 1 second.
   *
   * Returns the response from setting the shipping address.
   *
   * @param {Object} [options]
   * @param {Object} [options.addressToApply] - saved address the caller already
   *   chose (ExpressCheckout gates the default and picks a fallback); when
   *   omitted the default address is used, as before.
   */
  handleAddressExpressCheckout = async (options = {}) => {
    const { addressToApply } = options || {}
    if (isB2BAccount() && isB2BUser()) {
      const accountAdressResponse = accountsAddressContainer?.addressData || []

      this.addressLists = accountAdressResponse
    } else {
      const customerAddressResponse = await addressContainer.getProfileAddress()
      this.addressLists =
        customerAddressResponse && customerAddressResponse.length
          ? customerAddressResponse
          : []
    }
    const filteredAddress = this.filterSavedShippingAddresses(this.addressLists)
    // The caller's choice only counts when it is one of the market's shipping
    // addresses; otherwise fall back to the model's own pick from the filtered
    // list, never to the raw object (that bypassed the country / NLXX filter).
    const requestedAddress = isEmpty(addressToApply)
      ? undefined
      : filteredAddress.find(
          address =>
            address?.addressId == addressToApply.addressId ||
            address?.id == addressToApply.addressId
        )
    const defaultAddress =
      requestedAddress || this.pickExpressDefaultAddress(filteredAddress)
    if (!isEmpty(defaultAddress)) {
      let response = await checkoutContainer.setShippingAddress({
        ...defaultAddress,
        email: this.getShippingAddressEmail(defaultAddress),
      })
      let isSubscriptionCheckout = isSubscriptionOverrideCheckoutPage() || false
      response['items']?.length > 0 &&
        response['items'].forEach(item => {
          item &&
            item['skus'] &&
            item['skus'].map(bundleitem => {
              let inventoryProperties = bundleitem.inventoryProperties
              if (
                (inventoryProperties?.['available'] == false &&
                  inventoryProperties?.['backOrdered'] == true) ||
                (inventoryProperties?.['available'] == false &&
                  inventoryProperties?.['backOrdered'] == false) ||
                (inventoryProperties?.['available'] == false &&
                  inventoryProperties?.['backOrdered'] == null)
              ) {
                toastState.setToastMessage(
                  i18nTranslate(
                    'checkout.backOrder',
                    'Item got backordered or OOS'
                  ),
                  false
                )
                if (isSubscriptionCheckout) {
                  setTimeout(() => {
                    let originUrl =
                      window?.location?.href?.split(
                        pageNames.subscriptionCheckout
                      ) || []
                    window.location.replace(
                      `${originUrl?.[0]}${pageNames?.subscriptionCart}`
                    )
                  }, 1000)
                } else {
                  setTimeout(() => {
                    let originUrl =
                      window?.location?.href?.split(pageNames.checkout) ||
                      window?.location?.href?.split(
                        pageNames.expressCheckout
                      ) ||
                      []
                    window.location.replace(
                      `${originUrl?.[0]}${pageNames?.viewCart}`
                    )
                  }, 1000)
                }
              }
            })
        })
      return response
    } else return
  }

  handleExpressGpayPostData = async paymentType => {
    const bagValue = Math.abs(
      cartContainer?.cartResponse?.paymentValue?.totalAmountUnpaid || ''
    )

    await checkoutContainer.setCommunicationPreference(
      cartContainer?.cartResponse?.deliveryDetails?.address || {}
    )
    const { type, name } = this.getExpressPaymentIdentity(paymentType)
    const postData = [
      {
        name,
        status: 'active',
        type,
        amount: bagValue,
        isValid: true,
      },
    ]
    const response = await checkoutContainer.addAlternatePayment(postData)
    await cartContainer.viewCartForTax()
    return response
  }

  /**
   * Handles the checkout process for a PayPal payment.
   * Deletes any existing payments from the cart, calculates the total unpaid amount,
   * sets the shipping address, creates the PayPal payment payload,
   * calls the API to add the PayPal payment to the cart,
   * and returns the API response.
   */
  handleExpressCheckoutPostData = async paymentType => {
    if (cartContainer?.cartResponse?.payments !== undefined) {
      await this.deletePayment()
    }
    const bagValue = Math.abs(
      cartContainer?.cartResponse?.paymentValue?.totalAmountUnpaid || ''
    )

    await checkoutContainer.setCommunicationPreference(
      cartContainer?.cartResponse?.deliveryDetails?.address || {}
    )
    const { type, name } = this.getExpressPaymentIdentity(paymentType)
    const postData = [
      {
        name,
        status: 'active',
        type,
        amount: bagValue,
        isValid: true,
      },
    ]
    const response = await checkoutContainer.addAlternatePayment(postData)
    // TODO EX : Need to check below api required?
    await cartContainer.viewCart()
    return response
  }

  /**
   * Enables or disables PayPal checkout based on the provided flag.
   *
   * @param {boolean} flag - Whether to enable PayPal checkout.
   */
  paypalCheckoutEnable = flag => {
    this.paypalCheckout = flag
  }

  applePayCheckoutEnable = flag => {
    this.applePayCheckout = flag
  }

  gPayCheckoutEnable = flag => {
    this.gPayCheckout = flag
  }

  /**
   * Adds an alternate payment method to the cart.
   *
   * @param {Object} paymentDetail - The payment details object to add.
   * @returns {Promise} The API response from adding the payment.
   */
  addAlternatePayment = async (paymentDetail, headers) => {
    const effectiveCartType = this.getEffectiveCartType()

    const loadParams = {
      endPointName: 'addPaymentToCart',
      cartType: effectiveCartType,
      postData: paymentDetail,
    }
    // Optional request headers support
    if (headers && typeof headers === 'object') {
      loadParams.headers = headers
    }

    const response = await this.fetchResponse(loadParams)

    const { accountInfo, isDefault, type } = response?.[0] || []

    if (this.isSuccessResponse(response)) {
      /**
       * @info
       * GTM Datalayer -  Alternate payment success
       */

      TagManager.dataLayer({
        dataLayer: {
          event: 'paymentAddedComplete',
          ...getCheckoutGTMPageData({
            pageTitle: 'Payment Details',
          }),
          firstName: accountInfo?.name || '',
          lastName: accountInfo?.lastName || '',
          cardType: accountInfo?.type || '',
          isDefault: isDefault || '',
          platform: 'equinox',
        },
      })
      this.lastPaymentResponse = response
    } else {
      if (response?.code === 'PYMT_DUP_ENTRY_409') {
        toastState.setToastMessage(
          i18nTranslate(
            'payment.duplicatePaymentCard',
            'Payment card already exists'
          ),
          false
        )
      } else if (response?.code === 'PYMT_IBAN_USED') {
        // Without this the user sees a generic "try again" message and retries,
        // saving another profile record for the same IBAN each time.
        toastState.setToastMessage(
          i18nTranslate(
            'payment.ibanAlreadySaved',
            'This IBAN is already saved to your account. Please select it from your saved payment methods.'
          ),
          false
        )
      } else {
        toastState.setToastMessage(
          i18nTranslate(
            'payment.addPaymentFailure',
            'Sorry, we are unable to add your payment information. Please try again.'
          ),
          false
        )
      }

      /**
       * @info
       * GTM Datalayer -  Alternate payment failure
       */
      TagManager.dataLayer({
        dataLayer: {
          event: 'paymentError',
          ...getCheckoutGTMPageData({
            pageTitle: 'Payment Details',
          }),
          cardType: type || '',
          platform: 'equinox',
        },
      })
      if (!this.isSuccessResponse(response)) {
        await this.deletePayment()
        checkoutContainer.activePath = 'shippingMethods'
      }
    }
    return response
  }

  /**
   * @description addAlipayInitiate function initializes Alipay payment by calling the addAlipayToCart endpoint.
   * It constructs the callback url by getting the cartType and checking if its a native app.
   * It makes the API call with the constructed callback urls.
   * On failure it deletes the payment and updates the checkout.
   */
  addAlipayInitiate = async domainName => {
    await cartContainer.viewCart
    const url = this.constructUrlForNativeApp(domainName) || domainName || ''
    const urlWithCartType =
      this.constructUrlWithCartType(url) || domainName || ''
    const failureDomainName = this.constructUrlWithStatus(
      urlWithCartType,
      'alipay_status',
      'fail'
    )
    const successDomainName = this.constructUrlWithStatus(
      urlWithCartType,
      'alipay_status',
      'success'
    )
    const loadParams = {
      endPointName: 'addAlipayToCart',
      postData: {
        callbackUrlFail: failureDomainName,
        callbackUrlSuccess: successDomainName,
      },
    }
    const response = await this.fetchResponse(loadParams)
    if (!this.isSuccessResponse(response)) {
      await this.deletePayment()
    }
    this.alipayResponse = { ...response }
  }

  /**
   * Constructs the cart URL with the cart type appended as a query parameter.
   *
   * @param {string} domain - The base domain URL
   * @returns {string} The domain URL with the cart type query parameter appended
   */
  constructUrlWithCartType = (domain = '') => {
    const cartType = this.getCartType()
    const url = new URL(domain)
    url?.searchParams?.append('type', cartType)
    return url?.href || domain
  }

  /**
   * Constructs a URL by appending the product ID as a query parameter.
   *
   * @param {Object} options - An object containing the base URL.
   * @param {string} options.url - The base URL to construct the new URL from.
   * @returns {string} The URL with the product ID query parameter appended.
   */
  constructUrlWithExpressDetails = options => {
    const { url } = options || {}
    const cartType = this.getCartType()
    const updatedUrl = new URL(url)
    const lastPath = this.getLastPathFromUrl()
    const expressCheckout = pageNames.subscriptionCheckout?.includes(lastPath)
      ? pageNames.subscriptionCheckout?.replace('/', '')
      : pageNames.expressCheckout?.includes(lastPath)
        ? pageNames.expressCheckout?.replace('/', '')
        : ''
    if (expressCheckout || isExpressCheckout()) {
      updatedUrl?.searchParams?.append('page', lastPath)
    } else {
      updatedUrl?.searchParams?.append('productId', lastPath)
    }
    return updatedUrl?.href || url
  }

  /**
   * Extracts the last path name from URL
   *
   * @param {string} url - The URL to extract the product ID or page name.
   * @returns {string} The page name or product ID extracted from the URL.
   */
  getLastPathFromUrl = url => {
    const urlObj = new URL(url || location.href)
    const pathSegments = urlObj.pathname.split('/')
    const lastSegment = pathSegments[pathSegments.length - 1]
    return lastSegment
  }

  /**
   * Constructs the URL for native app by appending isNativeApp query parameter
   * if it doesn't already exist and the app is detected as a native app.
   *
   * @param {string} domain - The base domain URL
   * @returns {string} The domain URL with isNativeApp query parameter appended if needed
   */
  constructUrlForNativeApp = (domain = '') => {
    const url = new URL(domain)
    const isUrlHasNativeAppQuery =
      url?.searchParams?.get('isNativeApp') || false
    const isNativeApp = checkIsNativeApp() || false

    if (!isUrlHasNativeAppQuery && isNativeApp) {
      url?.searchParams?.append('isNativeApp', true)
      return url?.href || ''
    }
    return domain
  }

  /**
   * Constructs a URL by appending a key/value pair as a query parameter.
   *
   * @param {string} domain - The base URL
   * @param {string} key - The query parameter key
   * @param {string} value - The query parameter value
   * @returns {string} The URL with the query parameter appended
   */
  constructUrlWithStatus = (domain = '', key = '', value = '') => {
    const url = new URL(domain)
    url?.searchParams?.append(key, value)
    return url?.href || domain
  }

  /**
   * @description getCartType function is used to find the CartType from User GET API Response
   * @note For Klarna Payment, If cartType is 'USER', then ShoppingContext is deleted from localStorage
   * to avoid cartType mismatch issue, while Submitting Order.
   * @date 10/31/2023 - 1:23:58 PM
   */
  /**
   * Gets the cart type based on the cart response.
   * If cart type is 'USER', clears any existing shopping context in local storage
   * to avoid cart type mismatch issues when submitting order.
   * Logs errors if unable to clear shopping context.
   * Returns numeric cart type code.
   */
  getCartType = () => {
    let cartType = cartContainer?.cartResponse?.cartType || 'USER'
    const userId = customerContainer?.userId || ''
    if (cartType === 'USER') {
      let shoppingContext = getLocalStorage('shoppingContext') || {}
      if (Object.keys(shoppingContext).length > 0) {
        try {
          clearShoppingContext()
          trackErrorInInstana({
            errorReport: `Deleted the Shopping Context from localStorage for USER cartType - UserId: ${userId}`,
            errorData: { cartType: cartType },
          })
        } catch (e) {
          trackErrorInInstana({
            errorReport: `Unable to delete the Shopping Context from localStorage for USER cartType - UserId: ${userId}`,
            errorData: { cartType: cartType },
          })
        }
      } else {
        trackErrorInInstana({
          errorReport: `ShoppingContext Node is NOT there in LocalStorage for USER cartType - UserId: ${userId}`,
          errorData: { cartType: cartType },
        })
      }
    }

    return this.getCartTypeOrValue({
      isToReturnCode: true,
      cartType: cartType || 'USER',
    })
  }
  /**
   * Gets the effective cart type for API calls in subscription override checkout.
   * When in subscription override checkout context with cartType='USER', returns 'SUBSCRIPTION_OVERRIDE'.
   * Otherwise returns the actual cartType.
   *
   * @returns {string} 'SUBSCRIPTION_OVERRIDE' if in subscription override context, otherwise actual cartType
   */
  getEffectiveCartType = () => {
    const cartType = cartContainer?.cartResponse?.cartType || 'USER'
    const isSubscriptionOverride = isSubscriptionOverrideCheckoutPage()
    return isSubscriptionOverride && cartType === 'USER'
      ? 'SUBSCRIPTION_OVERRIDE'
      : cartType
  }

  /**
   * Gets the numeric cart type code or string cart type.
   *
   * @param {Object} options - Options object
   * @param {boolean} [options.isToReturnCode=false] - Whether to return numeric code or string type
   * @param {number} [options.typeCode] - Numeric cart type code
   * @param {string} [options.cartType] - String cart type
   * @returns {number|string} Numeric cart type code if isToReturnCode is true, otherwise returns string cart type
   */
  getCartTypeOrValue = options => {
    const { isToReturnCode = false, typeCode, cartType } = options || {}
    const cartTypes = {
      USER: 0,
      POCART: 1,
      MSCART: 2,
      EXPRESS: 3,
      SUBSCRIPTION_OVERRIDE: 4,
    }
    let type = ''
    if (isToReturnCode) {
      type = cartTypes[cartType]
    } else {
      for (let key in cartTypes) {
        if (typeCode == cartTypes[key]) {
          type = key
        }
      }
    }
    return type
  }

  /**
   * Initiates Klarna payment by constructing callback URLs with cart type,
   * calling addKlarnaToCart endpoint, and handling errors by displaying
   * toast message and deleting payment.
   *
   * @param {string} domainName - Base URL for Klarna redirect
   * @returns {Object} Response from addKlarnaToCart endpoint
   */
  initiateKlarnaPayment = async domainOrigin => {
    // await cartContainer.viewCart
    // @note To avoid Submit Order API CartType mismatch issue, cartType is appended to the redirection URL
    let domainName = domainOrigin
    let locale = getLocaleCodeFromUrl() || ''
    locale = locale?.toLowerCase()?.split('_')
    domainName = `${window.location.origin}/${locale?.[1]}/${locale?.[0]}${pageNames.klarnaCheckout}`
    if (isEquinoxMysite()) {
      domainName = `${window.location.origin}/${locale?.[1]}/${locale?.[0]}/mysite/${mysiteContainer.mysiteDomain}${pageNames.klarnaCheckout}`
    } else if (isEquinoxPOSite()) {
      const poSiteSponsor = getPoSponsorId()
      domainName = `${window.location.origin}/${locale?.[1]}/${locale?.[0]}/personal-offer/${poSiteSponsor}${pageNames.klarnaCheckout}`
    }

    const url = this.constructUrlForNativeApp(domainName) || domainName || ''
    let urlWithCartTypeAndProduct =
      this.constructUrlWithCartType(url) || domainName || ''

    if (isExpressCheckout()) {
      urlWithCartTypeAndProduct = this.constructUrlWithExpressDetails({
        url: urlWithCartTypeAndProduct,
      })
    }

    const failureDomainName = this.constructUrlWithStatus(
      urlWithCartTypeAndProduct,
      'klarna_status',
      'fail'
    )
    const successDomainName = this.constructUrlWithStatus(
      urlWithCartTypeAndProduct,
      'klarna_status',
      'success'
    )
    const cancelDomainName = this.constructUrlWithStatus(
      urlWithCartTypeAndProduct,
      'klarna_status',
      'cancel'
    )

    const effectiveCartType = this.getEffectiveCartType()

    const loadParams = {
      endPointName: 'addKlarnaToCart',
      postData: {
        callbackUrlFail: failureDomainName,
        callbackUrlSuccess: successDomainName,
        callbackUrlCancel: cancelDomainName,
      },
      cartType: effectiveCartType,
    }

    const response = (await this.fetchResponse(loadParams)) || {}
    if (!this.isSuccessResponse(response)) {
      const errorCode = response?.code || ''
      const phoneNumberMissingErrorMessage = i18nTranslate(
        'order.phoneNumberMissingError',
        'Unable to process your order. Please provide your phone number and try again'
      )
      const errorMessage =
        errorCode === 'ECKL0003'
          ? phoneNumberMissingErrorMessage
          : i18nTranslate(
              'checkout.paymentGeneralError',
              'Sorry, we were unable to process your payment. Please try again.'
            )
      toastState.setToastMessage(errorMessage)
      await this.deletePayment()
    }
    this.klarnaInitiateResponse = response
    return response || {}
  }

  initiateKlarnaTransactionStatusAPI = async props => {
    const { currencyCode = 'USD' } = props
    const effectiveCartType = this.getEffectiveCartType()

    const loadParams = {
      endPointName: 'klarnaTransactionStatus',
      cartType: effectiveCartType,
      postData: {
        currencyCode,
      },
    }
    const response = await this.fetchResponse(loadParams)
    return response
  }

  /**
   * Deletes the payment from the cart.
   *
   * @param {boolean} loyaltyPointShow - Whether to show loyalty points after deleting payment.
   * @returns {Promise} Response from deleting payment API call.
   */
  deletePayment = async loyaltyPointShow => {
    try {
      this.paymentDeletionInProgress = true //  Set flag before async operation
      const effectiveCartType = this.getEffectiveCartType()

      const loadParams = {
        endPointName: 'deletePaymentsFromCart',
        cartType: effectiveCartType,
      }
      const response = await this.fetchResponse(loadParams)
      if (this.isSuccessResponse(response)) {
        this.isLoyaltyPaid = false
      }
      await this.handleViewCart(response, loyaltyPointShow)
      checkoutContainer.activeSubmitOrderButton = true
      this.checkAndDisablePaymentContinueBtn()
      return response
    } finally {
      this.paymentDeletionInProgress = false // Clear flag after operation completes
    }
  }

  /**
   * Deletes a payment with the given ID from the cart.
   *
   * @param {string} paymentId - The ID of the payment to delete.
   * @param {boolean} isToHideCartCall - Whether to hide the cart call after deleting.
   * @returns {Promise} The response from the delete payment API call.
   */
  deletePaymentById = async (paymentId, isToHideCartCall = false) => {
    try {
      this.paymentDeletionInProgress = true
      const effectiveCartType = this.getEffectiveCartType()

      const loadParams = {
        endPointName: 'deletePaymentByIdFromCart',
        pathParams: paymentId,
        cartType: effectiveCartType,
      }
      const response = await this.fetchResponse(loadParams)
      if (!isToHideCartCall) {
        await this.handleViewCart(response)
      }
      checkoutContainer.activeSubmitOrderButton = true
      this.checkAndDisablePaymentContinueBtn()
      return response
    } finally {
      this.paymentDeletionInProgress = false
    }
  }
  /**
   * Gets the payment type based on the current domain.
   *
   * Checks if the current domain includes 'klarna_status' or 'alipay_status'
   * to determine if the payment type is 'KLARNA' or 'ALIPAY' respectively.
   *
   * Returns an empty string if no payment type is matched.
   */
  getPaymentType = () => {
    try {
      if (IS_BROWSER) {
        const domain = window?.location?.href || ''
        if (domain?.includes('klarna_status')) {
          return 'KLARNA'
        }
        if (domain?.includes('alipay_status')) {
          return 'ALIPAY'
        }
        if (domain?.includes('gps_status')) {
          return 'GPS'
        }
        return ''
      }
    } catch (error) {
      return ''
    }
  }

  /**
   * Deletes multiple payments from the cart, except Klarna and Alipay payments.
   *
   * Gets the applied payments on the cart. Checks the payment type based on the domain.
   * If the payment type is not Klarna or Alipay, loops through the applied payments
   * and deletes any that match the predefined list of payment types to delete.
   * Finally refetches the cart after deleting the payments.
   */
  deleteMultiplePaymentById = async () => {
    let appliedPayments = cartContainer?.cartResponse?.payments || []
    const paymentType = this.getPaymentType()

    if (
      appliedPayments?.length !== 0 &&
      paymentType !== 'KLARNA' &&
      paymentType !== 'ALIPAY' &&
      paymentType !== 'GPS'
    ) {
      // deleteMultiplePaymentById will be called in session init,
      // hence adding this condition to avoid deleting payments
      // in above mentioned payment's success scenarios
      let paymentsToBeDeleted = [
        'STORECREDIT',
        'LOYALTY',
        'CREDITCARD',
        'DEBITCARD',
        'ALIPAY',
        'VENMO',
        'KLARNA',
        'GOOGLEPAY',
        'APPLEPAY',
        'GPS',
      ]
      // after adding chile webpay payment,
      // when browser back is hit from webpay failure
      // payment is not getting deleted synchoronously
      // hence deleting via initializeCheckoutFlow function
      await Promise.all(
        appliedPayments?.map(async payment => {
          if (paymentsToBeDeleted?.includes(payment?.type)) {
            await this.deletePaymentById(payment.id, true)
          }
        })
      )
      await cartContainer.viewCart()
    }
  }

  /**
   * @description reviewOrder calls the reviewOrder API endpoint to review the order details before submitting the order.
   * It adds headers to show wholesale pricing if the user is a wholesale customer.
   * It also deletes any failed payments before returning the response.
   */
  reviewOrder = async () => {
    //adding showWholeSalePricing property in reviewOrder request header
    let shoppingContext
    let wholesale
    let retailSponsorId
    if (IS_BROWSER && typeof window !== 'undefined') {
      // shoppingContext = getLocalStorage('shoppingContext') || {}
      shoppingContext = getShoppingContext()
      let sponsor = getSessionStorage('sponsor') || ''
      const sponsorId = sponsor || ''
      if (Object.keys(shoppingContext).length > 0) {
        try {
          const contextValue = shoppingContext?.context
          if (
            contextValue === 'personal_offer' ||
            contextValue === 'storefront'
          ) {
            // Always send the offer sponsor (session SPONSOR) so reviewOrder
            // attribution stays with the offer, regardless of customer type.
            // The previous member-only override that sent profile
            // referenceAttribute as sponsorId has been removed.
            retailSponsorId = sponsorId
          }
        } catch (e) {
          console.error(
            'JSON.parse may be an error > checkoutContainer.reviewOrder() ',
            e
          )
        }
      }
    }
    let loadParams = {
      endPointName: 'reviewOrder',
      headers: retailSponsorId && {
        'x-nuskin-sponsorid': retailSponsorId,
      },
    }
    if (wholesale === 'true') {
      if (loadParams?.headers) {
        loadParams.headers = {
          ...loadParams?.headers,
          showWholesalePricing: wholesale,
        }
      } else {
        loadParams = {
          ...loadParams,
          headers: { showWholesalePricing: 'true' },
        }
      }
    }
    const response = await this.fetchResponse(loadParams)
    if (!this.isSuccessResponse(response)) {
      const effectiveCartType = this.getEffectiveCartType()

      const cleanupParams = {
        endPointName: 'deletePaymentsFromCart',
        cartType: effectiveCartType,
      }
      // A2 FIX: Log and handle cleanup failure instead of silently swallowing it
      const cleanupResponse = await this.fetchResponse(cleanupParams)
      if (!this.isSuccessResponse(cleanupResponse)) {
        console.error(
          'reviewOrder: payment cleanup after failure also failed',
          cleanupResponse
        )
        // Optionally notify user that cart may be in a partially-paid state
        // toastState.setToastMessage(i18nTranslate('checkout.paymentCleanupError', 'Please refresh and try again'))
      }
    }
    return response
  }

  /**
   * @description getCartTypeFromURL is used to get the CartType from the RedirectionURL for Klarna/Alipay Payment flow
   * @date 10/31/2023 - 1:29:08 PM
   */
  getCartTypeFromURL = () => {
    let cartType = ''
    try {
      if (IS_BROWSER) {
        const domain = window?.location?.href
        const hasCartTypeInURL =
          domain?.includes('type') &&
          (domain?.includes('klarna_status') ||
            domain?.includes('alipay_status'))

        if (hasCartTypeInURL) {
          const currentUrl = new URL(location.href)
          const type = currentUrl?.searchParams?.get('type')
          cartType = this.getCartTypeOrValue({
            typeCode: type || 0,
          })
        }
      }
    } catch (e) {
      trackErrorInInstana({
        errorReport: 'Unable to get CartType from URL',
        errorData: e,
      })
    }
    return cartType
  }

  /**
   * Returns the first valid GPS credit card processor object from globalPaymentResponse.
   * A valid processor must have a processorURL that does not include 'internal'.
   * @returns {Object|undefined} The valid processor object, or undefined if not found.
   */
  getValidGPSCreditCardProcessor = () => {
    const gpsCCList = this.globalPaymentResponse?.['CREDITCARD'] || []
    return gpsCCList.find(
      obj =>
        obj?.processorURL &&
        !obj.processorURL.toLowerCase().includes('internal')
    )
  }

  /**
   * Checks whether the global payment options response returned any credit card option.
   * @returns {boolean} True when at least one CREDITCARD option is available.
   */
  hasGPSCreditCardOption = () => {
    const gpsCCList = this.globalPaymentResponse?.['CREDITCARD'] || []
    return gpsCCList.length > 0
  }

  /**
   * Submits an order with the given payload.
   * @param {Object} payload - The payload for the order.
   * @returns {Promise} - A promise that resolves to the response of the order submission.
   */
  getPersonalOfferContext = sponsorId => {
    let grpOffer = sessionStorage.getItem('personalOffer')
    if (grpOffer && typeof grpOffer === 'string') {
      try {
        grpOffer = JSON.parse(grpOffer)
      } catch (e) {
        grpOffer = {}
        console.error('Personal Offer JSON Parse Error ', e)
        trackErrorInInstana({
          errorReport: 'Personal Offer JSON Parse Error',
          errorData: { error: e },
        })
      }
    } else {
      grpOffer = {}
    }

    const sessionIdObj = getLocalStorage('personalOffer_v2') || ''
    const isGrpOffer = (grpOffer?.isGroup && grpOffer?.isGroupOffer) || false
    return {
      source: 'Storefront',
      category: isGrpOffer ? 'GroupOffer' : 'PersonalOffer',
      sessionIdPOCart: sessionIdObj?.sessionId || '',
      pitchIdPOCart:
        grpOffer?.offerId || grpOffer?.pitchID || grpOffer?.shareLink?.id || '',
      sapIdPOCart: grpOffer?.sapId || sponsorId || '',
    }
  }
  getPersonalOfferSapId = () => {
    if (!IS_BROWSER) {
      return ''
    }
    try {
      const personalOfferData = JSON.parse(
        sessionStorage.getItem('personalOffer') || '{}'
      )
      return (
        personalOfferData?.sapId ||
        personalOfferData?.sponsorSapId ||
        personalOfferData?.pitchDetails?.sponsorSapId ||
        personalOfferData?.pitchDetails?.sapId ||
        personalOfferData?.offer?.sponsorSapId ||
        personalOfferData?.offer?.sapId ||
        ''
      )
    } catch (error) {
      trackErrorInInstana({
        errorReport: 'Personal Offer SAP ID parse failed',
        errorData: { error },
      })
      return ''
    }
  }

  getCartSponsorId = () => {
    const cartProperties = cartContainer?.cartResponse?.properties || {}
    return cartProperties?.sponsorId || cartProperties?.mysiteSponsorId || ''
  }

  /**
   * Shared PO sponsor precedence: offer data -> session -> URL, with the
   * cart-property fallback as an explicit optional final step so the two
   * call sites (submit order, express cart patch) can't drift apart.
   */
  resolvePoSponsorId = ({ includeCartFallback = false } = {}) => {
    return (
      this.getPersonalOfferSapId() ||
      getSessionStorage('sponsor') ||
      getPoSponsorId() ||
      (includeCartFallback ? this.getCartSponsorId() : '') ||
      ''
    )
  }

  // Single source of truth for "is this a PO/mysite context that requires
  // sponsor attribution" so resolveSubmitOrderSponsorId and the missing-
  // sponsor Instana guard can never diverge on when they check.
  isSponsorAttributionContext = contextValue =>
    contextValue === 'personal_offer' ||
    contextValue === 'storefront' ||
    isEquinoxPOSite()

  resolveSubmitOrderSponsorId = ({ sapIdPOCart, retailSponsorId } = {}) => {
    const contextValue = checkMysiteOrPersonalOffer()
    if (sapIdPOCart || retailSponsorId) {
      return sapIdPOCart || retailSponsorId
    }

    if (contextValue === 'personal_offer' || isEquinoxPOSite()) {
      return this.resolvePoSponsorId({ includeCartFallback: true })
    }

    if (contextValue === 'storefront') {
      return getSessionStorage('sponsor') || this.getCartSponsorId() || ''
    }

    return ''
  }

  /**
   * Express carts are not POCARTs, so the offer sponsor is never persisted on
   * the cart record; patch it so attribution does not rely only on a header.
   */
  updateExpressCartSponsorProperty = async () => {
    if (!IS_BROWSER || !isEquinoxPOSite() || !isExpressCart()) {
      return
    }
    const sponsorId = this.resolvePoSponsorId()
    if (!sponsorId) {
      return
    }
    const loadParams = {
      endPointName: 'updateBagAttributes',
      postData: { properties: { sponsorId } },
    }
    return await this.fetchResponse(loadParams)
  }

  getContextSourceDetails = contextText => {
    switch (contextText) {
      case 'storefront':
        return { source: 'Mysite', category: 'Standard', channel: '' }
      case 'MOBILE_AFFILIATE':
        return { source: 'Stela', category: 'Standard', channel: 'Mobile' }
      case 'MOBILE_CONSUMER':
        return { source: 'Vera', category: 'Standard', channel: 'Mobile' }
      case 'skin_consult':
        return { source: 'Vera', category: 'SkinConsult', channel: 'Mobile' }
      default:
        if (contextText?.toLowerCase() === 'mobile_prysm') {
          return { source: 'Prysm', category: 'Standard', channel: 'Mobile' }
        }
        return { source: '', category: '', channel: '' }
    }
  }

  resolveSubmitOrderContext = currentPayment => {
    const shoppingContext = getShoppingContext()
    const sponsor = isEquinoxMysite()
      ? mysiteContainer?.mysiteSponsor
      : getSessionStorage('sponsor') || ''
    // Shopping context can be missing after a redirect/reload, so fall back to
    // the URL-based detection instead of dropping offer attribution.
    const contextText =
      shoppingContext?.context || checkMysiteOrPersonalOffer() || ''
    const userId = customerContainer?.userId || ''
    const browserType = getBrowserType()

    trackErrorInInstana({
      errorReport: `User and Browser Details - While Submitting Order - UserId: ${userId} - Payment Type : ${currentPayment}`,
      errorData: {
        browserName: browserType?.name || '',
        browserVersion: browserType?.version || '',
        cartTypeFromUserAPI: cartContainer?.cartResponse?.cartType || '',
      },
    })

    const context = {
      source: '',
      category: '',
      wholesale: undefined,
      retailSponsorId: '',
      channel: '',
      sessionIdPOCart: '',
      pitchIdPOCart: '',
      sapIdPOCart: '',
      contextText,
      userId,
    }

    if (!(IS_BROWSER && typeof window !== 'undefined')) {
      return context
    }

    const sponsorId = sponsor || ''
    try {
      if (!Object.keys(shoppingContext).length && !contextText) {
        return context
      }
      if (!sponsorId) {
        trackErrorInInstana({
          errorReport: `Empty Sponsor Id: ${userId}`,
          errorData: {
            browserName: browserType?.name || '',
            browserVersion: browserType?.version || '',
            sponsorId: sponsorId,
            shoppingContext: shoppingContext,
          },
        })
      }

      const nextContext =
        contextText === 'personal_offer'
          ? this.getPersonalOfferContext(sponsorId)
          : this.getContextSourceDetails(contextText)

      Object.assign(context, nextContext)
      if (
        context.source?.toLowerCase() === 'mysite' ||
        context.source?.toLowerCase() === 'storefront'
      ) {
        context.retailSponsorId = sponsorId
      }
    } catch (e) {
      console.error('Error found at cart type in header request >>> ', e)
      trackErrorInInstana({
        errorReport: 'Fn Submit order',
        errorData: e,
      })
    }

    return context
  }

  getSubmitOrderHeaders = ({
    contextText,
    source,
    category,
    channel,
    pitchIdPOCart,
    sessionIdPOCart,
  }) => {
    const isMobileContext =
      (contextText && contextText == 'MOBILE_CONSUMER') ||
      contextText === 'MOBILE_AFFILIATE' ||
      contextText === 'skin_consult' ||
      contextText?.toLowerCase() === 'mobile_prysm'

    if (isMobileContext) {
      return {
        contextHeaders: {
          'x-nuskin-source': source || '',
          'x-nuskin-category': category || '',
          'x-nuskin-channel': channel || '',
        },
      }
    }

    if (
      contextText &&
      (contextText == 'personal_offer' || contextText == 'storefront')
    ) {
      const contextHeaders = {
        'x-nuskin-source': source || '',
        'x-nuskin-category': category || '',
      }

      if (pitchIdPOCart && !enablePORedesignFeature()) {
        contextHeaders['x-nuskin-pitchId'] = pitchIdPOCart
      }
      if (sessionIdPOCart && !enablePORedesignFeature()) {
        contextHeaders['x-nuskin-sessionId'] = sessionIdPOCart
      }
      return { contextHeaders }
    }

    return { contextHeaders: {} }
  }

  applySubmitOrderContextValidations = ({
    cartType,
    userId,
    currentPayment,
  }) => {
    const shoppingContextFromLocalStorage =
      getLocalStorage('shoppingContext') || {}
    if (
      cartType === 'USER' &&
      Object.keys(shoppingContextFromLocalStorage)?.length > 0
    ) {
      trackErrorInInstana({
        errorReport: `Cart Type mismatches with Local Storage ShoppingContext - UserId: ${userId} - Payment Type: ${currentPayment}`,
        errorData: {
          cartTypeInURL: cartType,
          hasShoppingContextInStorage:
            shoppingContextFromLocalStorage?.context || {},
        },
      })
      clearShoppingContext()
    }
  }

  applySubmitOrderAttributionHeaders = (
    loadParams,
    { sapIdPOCart, retailSponsorId, wholesale, pitchIdPOCart }
  ) => {
    const sponsorIdForHeader = this.resolveSubmitOrderSponsorId({
      sapIdPOCart,
      retailSponsorId,
    })
    if (sponsorIdForHeader) {
      loadParams.headers = {
        ...loadParams?.headers,
        'x-nuskin-sponsorid': sponsorIdForHeader,
      }
    } else if (
      IS_BROWSER &&
      this.isSponsorAttributionContext(checkMysiteOrPersonalOffer())
    ) {
      trackErrorInInstana({
        errorReport:
          'Submit Order API - Missing x-nuskin-sponsorid in PO/Mysite context',
        errorData: {
          context: checkMysiteOrPersonalOffer(),
          cartType: cartContainer?.cartResponse?.cartType || '',
          userId: customerContainer?.userId || '',
          pathname: window?.location?.pathname || '',
          sessionSponsor: getSessionStorage('sponsor') || '',
          poSponsorFromUrl: getPoSponsorId() || '',
          personalOfferSapId: this.getPersonalOfferSapId(),
          hasWindowShoppingContext: !!Object.keys(
            window?.shoppingContextJson || {}
          ).length,
          isExpressCart: isExpressCart(),
        },
      })
    }
    if (wholesale === 'true') {
      loadParams.headers = {
        ...loadParams?.headers,
        showWholesalePricing: 'true',
      }
    }

    if (enablePORedesignFeature()) {
      const activeOfferId = pitchIdPOCart || ''
      const poAuditSessionId = activeOfferId
        ? getPOAnalyticsSessionId(activeOfferId)
        : ''
      if (poAuditSessionId) {
        loadParams.headers = {
          ...loadParams?.headers,
          'x-nuskin-analyticsId': poAuditSessionId,
        }
      }
      if (activeOfferId) {
        setLocalStorage(PO_AUDIT_ORDER_OFFERID_KEY, activeOfferId)
      }
    }
  }

  getSubmitOrderPaymentFlags = () => {
    const existingPayments = cartContainer?.cartResponse?.payments || []
    const hasType = paymentType =>
      existingPayments?.some(payment => {
        const type = payment?.type?.toLowerCase()
        return type === paymentType
      }) || false

    return {
      isCreditOrDebitCardPayment:
        hasType('creditcard') || hasType('debitcard') || false,
      isVenmoPayment: hasType('venmo'),
      isGooglePayPayment: hasType('googlepay'),
      isApplePayPayment: hasType('applepay'),
    }
  }

  applySubmitOrderPayload = (loadParams, payload, paymentFlags) => {
    const { isVenmoPayment, isGooglePayPayment, isApplePayPayment } =
      paymentFlags
    if (typeof payload?.properties !== 'undefined') {
      if (isVenmoPayment || isApplePayPayment || isGooglePayPayment) {
        loadParams.postData = payload || {}
        return
      }

      loadParams.postData = {
        properties: {
          nonceToken: payload?.properties?.nonceToken || '',
        },
      }
      return
    }

    if (payload && payload !== -1) {
      loadParams.postData = { payload }
    }
  }

  ensureSubmitOrderProperties = loadParams => {
    if (!loadParams?.postData) {
      loadParams.postData = { properties: {} }
      return loadParams.postData.properties
    }
    if (!loadParams?.postData?.properties) {
      loadParams.postData.properties = {}
    }
    return loadParams.postData.properties
  }

  applyGiftAndDropShipping = loadParams => {
    if (this.giftPayLoad) {
      const properties = this.ensureSubmitOrderProperties(loadParams)
      properties.enableGiftReceipt = true
      properties.customGiftMessage = this.giftMessage
    }

    const { dropShippingEnabled = 'false' } =
      cartContainer?.cartResponse?.properties || {}
    if (this.dropShippingPayLoad && dropShippingEnabled === 'true') {
      const properties = this.ensureSubmitOrderProperties(loadParams)
      properties.dropShipping = true
    }
  }

  is3DSEnabledForSubmitOrder = () => {
    if (!IS_BROWSER) {
      return false
    }

    const urlParams = new URLSearchParams(window.location.search)
    const gpsStatus = urlParams.get('gps_status')
    const validProcessorObj = this.getValidGPSCreditCardProcessor()

    return (
      gpsStatus?.toLowerCase() === 'approved' &&
      hasCardPaymentOnCart(cartContainer?.cartResponse?.payments) &&
      isPaymetric3DSProcessor(validProcessorObj)
    )
  }

  fetchSubmitOrderResponse = async (
    loadParams,
    isToPatchDeviceData,
    is3DSEnabled
  ) => {
    if (!(IS_BROWSER && window?._bcn != undefined && isToPatchDeviceData)) {
      return await this.fetchResponse(loadParams)
    }

    const ipAddress = await getBrowserIpAddress()
    const enableFallbackDeviceToken = isFeatureEnabled(
      'enableFallbackDeviceToken'
    )
    const fetchedDeviceToken = window?._bcn?.getToken()
    const deviceToken =
      fetchedDeviceToken || (enableFallbackDeviceToken ? null : '')
    const deviceId = window?._bcn?.dvc?.getTID()
    const properties = this.ensureSubmitOrderProperties(loadParams)

    properties.deviceToken = deviceToken
    properties.deviceId = deviceId
    properties.ipAddress = ipAddress
    if (is3DSEnabled) {
      properties['3dsEnabled'] = true
    }

    return await this.fetchResponse(loadParams)
  }

  // Exits a stuck Express/Buy Now cart mode (abandoned or declined payment) so
  // later cart fetches return the customer's real USER cart, not EXPRESS
  resetExpressCartFlags = () => {
    setLocalStorage('isExpressCart', false)
    this.renderExpressPDPCart =
      this.showExpressCheckoutDrawer =
      this.showExpressCheckoutModalBody =
        false
  }

  handleSubmitOrderSuccess = async (
    response,
    { source, category, channel }
  ) => {
    if (isExpressCheckout()) {
      // also clears isExpressCart so later cart calls stop targeting the now-consumed EXPRESS cart
      this.resetExpressCartFlags()
      this.expressPaymentAdded = false
    }

    this.orderId = response && response.orderId
    setSessionStorage('orderID', this.orderId)
    deleteFromSessionStorage('utmInfo')
    deleteFromSessionStorage('vipCheckboxStatus')
    deleteFromSessionStorage('smsOptInStatus')
    deleteFromSessionStorage('emailOptInStatus')
    deleteFromSessionStorage('legalAgreementStatus')
    if (accountsContainer) {
      accountsContainer.isGuestCheckoutLegalAgreementChecked = false
      accountsContainer.isGuestCheckoutShippingAddressConfirmed = false
    }

    const cartData = cartContainer?.cartResponse || {}
    const shippingMethods =
      cartContainer?.cartResponse?.deliveryDetails?.methods || []
    const selectedMethod = shippingMethods?.find(method => method?.isSelected)
    const isBOPIS = selectedMethod?.properties?.BOPIS === true
    const isRecipientFormEnabled = isFeatureEnabled('enablePickupRecipientForm')
    if (isBOPIS && isRecipientFormEnabled) {
      // form observables doesn't persist after payment redirections
      // also, cart data doesn't persist after order confirmation
      // hence, observables required to display QR after redirecting to orderConfirmation
      this.recipientName =
        cartContainer?.cartResponse?.properties?.recipientName || ''
      this.recipientPhone =
        cartContainer?.cartResponse?.properties?.recipientPhone || ''
    }
    const customerEmail = cartData?.deliveryDetails?.address?.email || ''
    const customerType = customerContainer.isRegisterUser
      ? customerContainer?.profileResponse?.accounts?.accountType
      : 'Guest User'
    const isFromUTTEvent = true
    const { enableEQFastFollow = false } = APPConfig?.getAppConfig() || false
    const isToTrackUTTConversion = convertToBoolean(enableEQFastFollow)
      ? !checkMysiteOrPersonalOffer()
      : true

    setInsiderTransactionData({
      orderId: this.orderId,
      cartResponse: cartData,
      source,
      category,
      channel,
    })

    if (isToTrackUTTConversion) {
      trackUTTConversion({
        orderId: this.orderId,
        customProfileId:
          customerContainer?.profileResponse?.accounts?.referenceAttribute ||
          '',
        customerId: cartData?.userId || '',
        customerEmail: customerEmail || '',
        customerStatus: customerType,
        currencyCode: cartData?.currencyCode || '',
        orderPromoCode: cartData?.promotionDetails?.codes?.[0]?.code || '',
        orderDiscount:
          cartData?.currencySign + cartData?.value?.cartDiscount || '',
        items: getCheckoutProduct(cartData?.items, '', isFromUTTEvent),
      })
    }

    if (this.giftMessage) {
      trackCheckoutGiftReceipt({
        eventType: 'select_gift',
        message: this.giftMessage,
      })
    }

    if (!customerContainer.isRegisterUser) {
      await customerContainer.logout(true)
      await customerContainer.getProfile()
    }

    const isToUpdateLegalAddressFlag = isToShowLegalAddressChanges() || false
    if (isToUpdateLegalAddressFlag) {
      const isLegalAddressAlreadyExists = accountsContainer.profileResponse
        ?.addresses?.[0]?.addressLine1
        ? true
        : false
      checkoutContainer.isUserHasLegalAddress =
        isLegalAddressAlreadyExists || false
      deleteCookie('isToShowLegalAddressAccordion')
    }

    const isLegalTaxIdEnabled =
      convertToBoolean(APPConfig?.getAppConfig()?.enableLegalTaxId) || false
    if (isLegalTaxIdEnabled) {
      deleteCookie('hideLegalTaxId')
    }
  }

  submitOrder = async payload => {
    const currentPayment =
      cartContainer?.cartResponse?.payments?.[0]?.type || ''
    const submitContext = this.resolveSubmitOrderContext(currentPayment)
    let {
      source,
      category,
      wholesale,
      retailSponsorId,
      channel,
      sessionIdPOCart,
      pitchIdPOCart,
      sapIdPOCart,
      contextText,
      userId,
    } = submitContext

    const { contextHeaders } = this.getSubmitOrderHeaders({
      contextText,
      source,
      category,
      channel,
      pitchIdPOCart,
      sessionIdPOCart,
    })

    if (isGuestCheckoutEnabledForWeb() && !checkMysiteOrPersonalOffer()) {
      retailSponsorId = accountsContainer?.getUserTypeSponsorId()
    }

    const cartType = this.getCartTypeFromURL() || ''
    const loadParams = {
      endPointName: 'submitOrder',
      headers:
        isGuestCheckoutEnabledForWeb() && !checkMysiteOrPersonalOffer()
          ? { 'x-nuskin-source': 'Storefront' }
          : contextHeaders,
      ...(cartType && { cartType }),
    }

    if (cartType) {
      trackErrorInInstana({
        errorReport: `Submit Order API - CartType from Redirection URL - UserId: ${userId} - Payment Type: ${currentPayment}`,
        errorData: { cartTypeInURL: cartType },
      })
    }

    this.applySubmitOrderContextValidations({
      cartType,
      userId,
      currentPayment,
    })
    this.applySubmitOrderAttributionHeaders(loadParams, {
      sapIdPOCart,
      retailSponsorId,
      wholesale,
      pitchIdPOCart,
    })

    const paymentFlags = this.getSubmitOrderPaymentFlags()
    this.applySubmitOrderPayload(loadParams, payload, paymentFlags)
    this.applyGiftAndDropShipping(loadParams)

    const isToPatchDeviceData =
      paymentFlags.isGooglePayPayment ||
      paymentFlags.isApplePayPayment ||
      paymentFlags.isCreditOrDebitCardPayment
    const is3DSEnabled = this.is3DSEnabledForSubmitOrder()
    const response = await this.fetchSubmitOrderResponse(
      loadParams,
      isToPatchDeviceData,
      is3DSEnabled
    )

    if (this.isSuccessResponse(response)) {
      await this.handleSubmitOrderSuccess(response, {
        source,
        category,
        channel,
      })
    } else {
      const errorMessage =
        response?.errorMessage || response?.message || response?.status || ''
      trackErrorInInstana({
        errorReport: `Submit order API Failed for USER - ${userId} - Payment Type - ${currentPayment}`,
        errorData: { errorMessage, response: response },
      })
    }

    trackErrorInInstana({
      errorReport: `Submit order tracking - ${this.orderId} - Payment Type: ${currentPayment}`,
      errorData: loadParams,
    })

    trackErrorInInstana({
      errorReport: `Submit order context - ${contextText} - Payment Type: ${currentPayment}`,
      errorData: loadParams,
    })

    return response
  }

  //Loyality Payment POST Call
  /**
   * Adds loyalty points payment to cart.
   *
   * @param {number} paymentData - Loyalty points to pay with
   * @returns {Promise} Response from API call
   */
  addLoyaltyToCart = async paymentData => {
    let payment = parseFloat(paymentData)
    //const cardType ='LOYALTY'
    //const valueType =cardType.toLowerCase() === 'loyalty' ? 'CASH' : 'CURRENCY'
    const loadParams = {
      endPointName: 'addPaymentToCart',
      postData: [
        {
          type: 'LOYALTY',
          valueType: 'POINTS',
          value: payment,
          amount: payment,
          option: {
            addPaymentToProfile: false,
            useDefaultPayment: false,
            setAsDefaultPaymentInProfile: false,
          },
        },
      ],
    }
    const response = await this.fetchResponse(loadParams)
    if (this.isSuccessResponse(response)) {
      this.isLoyaltyPaid = true
    }
    this.handleViewCart(response)
    this.paymentRefId = response
    return response
  }

  /**
   * Adds a promotion/coupon code to the cart.
   *
   * @param {string} couponCode - The coupon code to add
   * @returns {Promise} The response from the API call
   */
  addPromo = async couponCode => {
    const loadParams = {
      endPointName: 'addPromo',
      postData: [
        {
          code: couponCode,
        },
      ],
    }

    const response = await this.fetchResponse(loadParams)
    if (this.isSuccessResponse(response)) {
      this.isCouponPaid = true
    }
    await this.handleViewCart(response)
    this.appliedCouponCodes =
      cartContainer?.cartResponse?.promotionDetails?.codes?.map(
        promo => promo?.code
      ) || []
    return response
  }
  /**
   * Deletes a promotion/coupon code from the cart.
   *
   * @param {string} promoCode - The coupon code to delete
   * @returns {Promise} The response from the API call
   */
  deletePromo = async promoCode => {
    const loadParams = {
      endPointName: 'deletePromo',
    }
    if (promoCode) {
      loadParams.pathParams = `${promoCode}`
    }
    const response = await this.fetchResponse(loadParams)
    if (this.isSuccessResponse(response)) {
      this.isCouponPaid = false
    }
    await this.handleViewCart(response)
    this.appliedCouponCodes =
      cartContainer?.cartResponse?.promotionDetails?.codes?.map(
        promo => promo?.code
      ) || []
    return response
  }
  /**
   * Deletes the loyalty discount reward from the cart.
   *
   * Makes an API call to delete any applied loyalty rewards.
   * Updates cart and loyalty paid state on success.
   *
   * @returns {Promise<Object>} The API response object.
   */
  deleteDiscountReward = async () => {
    const loadParams = {
      endPointName: 'deleteLoyaltyRewardsFromCart',
    }
    const response = await this.fetchResponse(loadParams)
    if (this.isSuccessResponse(response)) {
      this.isLoyaltyPaid = false
    }
    this.handleViewCart(response)
    return response
  }
  //Cart Patch call if discountModelRewardTypes available
  /**
   * Adds a loyalty discount reward to the cart.
   *
   * Makes an API call to apply any available loyalty discount rewards.
   * Updates cart and loyalty paid state on success.
   *
   * @param {Object} discountData - Object containing loyalty point info
   * @returns {Promise} The API response
   */
  addDiscountReward = async discountData => {
    let payment = parseFloat(discountData?.loyaltyPoint || 0)

    const loadParams = {
      endPointName: 'updateBagAttributes',
      postData: {
        loyaltyDetails: [
          {
            value: payment,
            points: payment,
            type: 'LOYALTY',
            valueType: 'POINTS',
          },
        ],
      },
    }
    const response = await this.fetchResponse(loadParams)
    if (this.isSuccessResponse(response)) {
      this.isLoyaltyPaid = true
    }
    this.handleViewCart(response)
    return response
  }
  /**
   * Updates the cost center ID in the cart.
   *
   * Makes an API call to update the cost center ID in the cart.
   * Updates cart response with new cost center ID on success.
   * Shows error toast message on failure.
   *
   * @param {string} costCenterId - The cost center ID to update in the cart
   * @returns {Promise} The API response
   */
  updateCostCenterToCart = async costCenterId => {
    const loadParams = {
      endPointName: 'updateBagAttributes',
      postData: { costCenterId },
    }
    const response = await this.fetchResponse(loadParams)
    if (checkoutContainer.isSuccessResponse(response)) {
      cartContainer.cartResponse.costCenterId = costCenterId
    } else {
      toastState.setToastMessage(
        i18nTranslate(
          'checkout.costCenterUpdateError',
          'Unable to update the cost center'
        ),
        false
      )
    }
    return response
  }
  /**
   * Validates the cost center for the current cart.
   *
   * Constructs API params to validate if the cost center can be used for the cart total.
   * Calls API endpoint to validate cost center.
   *
   * @returns {Promise} The API response from the validation call.
   */
  validateCostCenter = async () => {
    const bagValue = cartContainer?.cartResponse?.paymentValue?.bagValue || ''
    const costCenterId = cartContainer?.cartResponse?.costCenterId || ''

    const loadParams = {
      endPointName: 'validateCostCenter',
      pathParams: `${customerContainer.accountId}/buyers/costcentres/${costCenterId}/validateOrderAmount`,
      queryParam: { amount: bagValue },
    }
    const response = await this.fetchResponse(loadParams)
    return response
  }
  /**
   * Gets all cost centers for the logged in customer.
   *
   * If the customer is registered, gets the account ID and calls the API endpoint to get all cost centers for that account.
   *
   * Returns the API response with the cost centers.
   * If no customer is logged in, returns empty string.
   */
  getAllCostCenter = async () => {
    if (customerContainer.isRegisterUser) {
      const accountId = await this.getAccountId()
      const loadParams = {
        endPointName: 'getAllCostCenter',
        pathParams: `${accountId}/buyers/costcentres`,
      }
      const response = await this.fetchResponse(loadParams)
      return response
    }
    return ''
  }
  /**
   * Fetches shipping method disclaimer content from Contentful.
   *
   * Configures the API request to get entries from the
   * shippingMethodDisclaimers content type. Enables preview mode
   * if configured in the app config.
   *
   * Saves the response to the shippingMethodDisclaimers
   * property on the CheckoutContainer instance.
   */
  getShippingMethodDisclaimers = async () => {
    const { enableContentfulPreview } = getAppConfig()
    const loadParams = {
      endPointName: 'getContentfulFromEntryId',
      queryParams: {
        limit: 100,
        contentType: 'shippingMethodDisclaimers',
        isPreview: enableContentfulPreview,
      },
    }
    this.shippingMethodDisclaimers = await this.fetchResponse(loadParams)
  }

  getGlobalPaymentOptions = async (
    isSubscriptionProductInCart = false,
    isFromPDP = false
  ) => {
    this.isGlobalPaymentCallInProgress = true
    let isSubscriptionCheckout = isSubscriptionOverrideCheckoutPage() || false
    let xNuskinCategory = 'OneTime'
    if (!isSubscriptionCheckout && isSubscriptionProductInCart) {
      xNuskinCategory = 'Subscription'
    }

    // Subscription payment options are never a one-time order, and the cart read
    // here can be an unrelated USER cart (e.g. subscription dashboard modal).
    const hasOneTime =
      xNuskinCategory === 'Subscription'
        ? false
        : cartContainer.hasOneTimeProducts()

    const contextHeaders = {
      'x-nuskin-channel': 'WEB',
      'x-nuskin-category': xNuskinCategory,
      'x-nuskin-onetimeorder': hasOneTime,
    }

    const loadParams = {
      endPointName: 'getGlobalPaymentOptions',
      headers: contextHeaders,
      ...(isFromPDP && { queryParams: { isFromPDP: true } }),
    }

    const response = await this.fetchResponse(loadParams)
    if (!this.isSuccessResponse(response)) {
      trackErrorInInstana({
        errorReport: 'Global Payment - GET API failed',
        errorData: response,
      })
    }
    this.globalPaymentOptionsListResponse = response || {}
    this.globalPaymentResponse = response?.response || {}
    this.globalPaymentInstallmentsResponse = response?.installments || {}
    this.isGlobalPaymentCallInProgress = false
    return response
  }

  initiateGlobalPayment = async (
    domainOrigin = '',
    isSubscriptionProductInCart,
    processorObj
  ) => {
    // The Submit Order flow does not pass a processor, so resolve it from the
    // GPS options; otherwise 3DS could never be detected on that path. SEPA,
    // wire and wallet payments reach this same call, so the credit card
    // processor is only resolved when the cart actually holds a card payment.
    const validProcessorObj =
      processorObj ??
      (hasCardPaymentOnCart(cartContainer?.cartResponse?.payments)
        ? this.getValidGPSCreditCardProcessor()
        : undefined) ??
      {}
    const isNativeApp = checkIsNativeApp() || false
    let isSubscriptionCheckout = isSubscriptionOverrideCheckoutPage() || false
    let modifiedURL = isSubscriptionCheckout
      ? 'subscriptionCheckout'
      : 'expressCheckout'
    // let domainName = domainOrigin
    let locale = getLocaleCodeFromUrl() || ''
    locale = locale?.toLowerCase()?.split('_')
    let domainName = ''
    if (isEquinoxPOSite()) {
      const sponsorId = getPoSponsorId()
      if (sponsorId) {
        const poPath = `personal-offer/${sponsorId}`
        domainName = `${window.location.origin}/${locale?.[1]}/${locale?.[0]}/${poPath}/${modifiedURL}`
      }
    } else if (isEquinoxMysite()) {
      const mysiteSponsor = getMysiteSponsor()
      if (mysiteSponsor) {
        const mysitePath = `mysite/${mysiteSponsor}`
        domainName = `${window.location.origin}/${locale?.[1]}/${locale?.[0]}/${mysitePath}/${modifiedURL}`
      }
    } else {
      domainName = `${window.location.origin}/${locale?.[1]}/${locale?.[0]}/${modifiedURL}`
    }
    // const domainName = window?.location?.href || ''
    const url = this.constructUrlForNativeApp(domainName) || domainName || ''
    let urlWithCartType = this.constructUrlWithCartType(url) || domainName || ''
    // Append is3DS=true if the processor is Paymetric 3DS (PAYM, external URL)
    const isPaymetric3DS = isPaymetric3DSProcessor(validProcessorObj)
    if (isPaymetric3DS) {
      if (IS_BROWSER) {
        const urlObj = new URL(urlWithCartType, window.location.origin)
        urlObj.searchParams.set('is3DS', 'true')
        urlWithCartType = urlObj.toString()
      }
    }
    const hasOneTime = cartContainer.hasOneTimeProducts()
    const contextHeaders = {
      'x-nuskin-channel': 'WEB',
      'x-nuskin-category':
        isSubscriptionProductInCart || isSubscriptionCheckout
          ? 'Subscription'
          : 'OneTime',
      'x-nuskin-onetimeorder': hasOneTime,
    }

    const loadParams = {
      endPointName: isPaymetric3DS
        ? 'submitOrderForPaymetric3DS'
        : 'submitOrderForGlobalPayment',
      headers: contextHeaders,
      postData: {
        // successCallbackUrl: this.constructUrlWithStatus(
        //   urlWithCartType,
        //   'gps_status',
        //   'success'
        // ),
        // failedCallbackUrl: this.constructUrlWithStatus(
        //   urlWithCartType,
        //   'gps_status',
        //   'fail'
        // ),
        // pendingCallbackUrl: this.constructUrlWithStatus(
        //   urlWithCartType,
        //   'gps_status',
        //   'pending'
        // ),
        landingUrl: urlWithCartType,
      },
    }
    const response = (await this.fetchResponse(loadParams)) || {}
    trackErrorInInstana({
      errorReport: 'Global Payment - Submit API Response',
      errorData: response,
    })
    if (!this.isSuccessResponse(response)) {
      const errorMessage =
        response?.message ||
        i18nTranslate(
          'order.generalError',
          'Sorry, we are unable to place order. Please try again.'
        )
      toastState.setToastMessage(errorMessage)
      await this.deletePayment()
    }
    return response || {}
  }

  updateGlobalPaymentStatus = async paymentData => {
    const loadParams = {
      endPointName: 'gpsUpdate',
      postData: paymentData,
    }
    const response = await this.fetchResponse(loadParams)
    trackErrorInInstana({
      errorReport: 'Global Payment - Update API Response',
      errorData: response,
    })
    return response || {}
  }

  /**
   * Loads the Google Pay client script if it is not already loaded and the Google Pay payment is enabled.
   */
  loadGooglePayClientScript = () => {
    try {
      if (IS_BROWSER) {
        const isScriptNotAlreadyLoaded = !document.getElementById(
          'googlePayPaymentScript'
        )
        if (isScriptNotAlreadyLoaded) {
          const googlePayClientScript =
            APPConfig.getAppConfig()?.googlePayClientScript || ''
          const script = document.createElement('script')
          script.id = 'googlePayPaymentScript'
          script.src = googlePayClientScript
          document.body.appendChild(script)
        } else {
          console.log('Google Pay Script already loaded or payment disabled')
        }
      }
    } catch (e) {
      console.log('Error loading Google Pay client script', e)
    }
  }

  /**
   * Loads the Google Pay BrainTree script if it is enabled in the app configuration and not already loaded.
   */
  loadGooglePayBrainTreeScript = () => {
    try {
      if (IS_BROWSER) {
        const isScriptNotAlreadyLoaded = !document.getElementById(
          'googlePayBrainTreeScript'
        )
        if (isScriptNotAlreadyLoaded) {
          const googlePayBrainTreeScript =
            APPConfig.getAppConfig()?.googlePayBrainTreeScript || ''
          const script = document.createElement('script')
          script.id = 'googlePayBrainTreeScript'
          script.src = googlePayBrainTreeScript
          document.body.appendChild(script)
        } else {
          console.log(
            'Brain Tree Google Pay Client Script already loaded or Payment disabled'
          )
        }
      }
    } catch (e) {
      console.log('Error loading Brain Tree Google Pay client script', e)
    }
  }

  hideCouponCodeForPOAndMysite = () => {
    let hideCouponCode = false
    try {
      if (IS_BROWSER) {
        const shoppingContext = getShoppingContext()
        if (Object.keys(shoppingContext)?.length > 0) {
          const contextValue = shoppingContext?.context || ''
          /**
           * @description Hide coupon code in Po site if promotion is added to cart [CX16-10005]
           * @date 9/29/2023 - 2:27:06 PM
           */
          if (contextValue === 'personal_offer') {
            // For Product Offer 2.0, hide the promo code section only when the
            // offer already applies a percentage discount (e.g. "Offer Discount
            // - 15% OFF"); the percentage varies per promotion. When no such
            // offer discount is applied, keep the promo code section visible.
            if (enablePORedesignFeature()) {
              hideCouponCode = hasProductOfferPercentageDiscount(
                cartContainer.cartResponse
              )
            } else {
              // Legacy PO behavior
              const hideCouponCodeInPOCheckout = !(
                APPConfig?.getAppConfig()?.enableCouponCodeForPoSite === 'true'
              )
              const promotionCheck = convertToBoolean(
                cartContainer.cartResponse?.properties
                  ?.isExcludedPromoCodeAvailInCart || false
              )

              if (hideCouponCodeInPOCheckout) {
                hideCouponCode = true
              } else {
                hideCouponCode = promotionCheck
              }
            }
          }
          /**
           * @description Hide Coupon code in Mysite if the user type doesn't match any value in enableCouponCodeForMySite of appConfig[CX16-9759]
           * @date 9/29/2023 - 2:29:55 PM
           */
          if (contextValue === 'storefront') {
            const enableCouponCodeForMySite =
              APPConfig?.getAppConfig()?.enableCouponCodeForMySite || []
            const accType =
              customerContainer?.profileResponse?.accounts?.accountType || ''
            if (!customerContainer.isRegisterUser) {
              if (!enableCouponCodeForMySite?.includes('Guest')) {
                hideCouponCode = true
              }
            } else if (customerContainer.isRegisterUser) {
              if (!enableCouponCodeForMySite?.includes(accType)) {
                hideCouponCode = true
              }
            }
          }
        } else {
          hideCouponCode = false
        }
      }
    } catch (e) {
      console.error('JSON.parse may be an error CheckoutView2', e)
    }
    return hideCouponCode
  }

  getWirePaymentTranslationData = () => {
    const uid = 'blt6128256f40b5aa50'
    let referenceId = 'payment_component'
    ContentStack.getReference(referenceId, uid, this.props).then(response => {
      const translationsForWirePayment =
        response?.other_payment_methods?.filter(
          payment => payment.payment_type_id == 8
          // id for wirepayment in contentstack is 8
        )
      if (IS_BROWSER && translationResources) {
        this.wirepayment_nextgen_payment_method_text =
          translationsForWirePayment?.[0]?.nextgen_payment_method_text || ''
      }
    })
  }

  getPaymentFromGPS = async (isFromPDP = false, isBuyNowFlow = false) => {
    const enableGlobalPaymentSystem = isGPSEnabled()
    let getGpsPaymentList = ''
    if (enableGlobalPaymentSystem) {
      // Buy Now (express) flow skips the cached PDP (USER) response so it
      // fetches fresh EXPRESS payment options.
      if (
        !isBuyNowFlow &&
        this.globalPaymentResponse &&
        Object.keys(this.globalPaymentResponse).length > 0
      ) {
        getGpsPaymentList = this.globalPaymentResponse
      } else {
        const isSubscriptionProductInCart =
          cartContainer.hasSubscriptionProduct()
        const response = await checkoutContainer.getGlobalPaymentOptions(
          isSubscriptionProductInCart,
          isFromPDP
        )
        getGpsPaymentList = response.response
      }
      // Get all supported payment types from API response and return as array
      const supportedPaymentTypes = Object.keys(getGpsPaymentList || {})
      return supportedPaymentTypes
    }
  }

  getPaymentDisplayName = async (paymentName, gpsPaymentList) => {
    let gpsApiResponse = ''
    let paymentDisplayName = ''

    if (isGPSEnabled()) {
      if (gpsPaymentList) {
        gpsApiResponse = gpsPaymentList
      } else {
        const isSubscriptionProductInCart =
          cartContainer.hasSubscriptionProduct()
        const response = await this.getGlobalPaymentOptions(
          isSubscriptionProductInCart
        )
        gpsApiResponse = response.response
      }

      Object.keys(gpsApiResponse).forEach(key => {
        if (key === findGpsOptionKey(gpsApiResponse, paymentName)) {
          const paymentConfig = gpsApiResponse[key]
          if (Array.isArray(paymentConfig) && paymentConfig.length > 0) {
            paymentDisplayName = paymentConfig[0]?.displayName || key
          } else {
            paymentDisplayName = key
          }
        }
      })
      return paymentDisplayName
    }
  }

  getUnpaidPaymentConfig = type => {
    const gpsBasedPaymentTypes = getGPSConfigValue('gpsBasedPaymentTypes') || []
    const appConfigGpsBasedPaymentType = Array.isArray(gpsBasedPaymentTypes)
      ? gpsBasedPaymentTypes
      : []

    const gpsPaymentSupport = [
      'Chile_WebPay',
      'Mercado_Pago',
      'MODO',
      'Razorpay',
      ...appConfigGpsBasedPaymentType,
    ]
    let typeMap = {
      chilewebpay: 'Chile_WebPay',
      'mercado pago': 'Mercado_Pago',
      modo: 'MODO',
      wire: 'banktransfer',
      razorpay: 'Razorpay',
    }

    if (isINMarket()) {
      gpsPaymentSupport.push('creditcards', 'UPI')
      typeMap = { ...typeMap, creditcard: 'creditcards', upi: 'UPI' }
    }

    if (
      getGPSConfig('enableKlarnaGPSFlow') &&
      type?.toLowerCase() === 'klarna'
    ) {
      gpsPaymentSupport.push('Klarna')
      typeMap = { ...typeMap, klarna: 'Klarna' }
    }

    return { gpsPaymentSupport, typeMap }
  }

  shouldHandleSubscriptionPayment = () =>
    isINMarket() && cartContainer.hasSubscriptionProduct()

  shouldExtractGpsPaymentConfigName = type =>
    (getGPSConfig('enableKlarnaGPSFlow') && type?.toLowerCase() === 'klarna') ||
    this.shouldHandleSubscriptionPayment()

  getGpsPaymentConfigName = (type, gpsPaymentList = {}) => {
    const paymentKey = findGpsOptionKey(gpsPaymentList, type)
    const paymentConfigs = paymentKey ? gpsPaymentList[paymentKey] : []

    if (
      Array.isArray(paymentConfigs) &&
      paymentConfigs.length > 0 &&
      paymentConfigs[0].name
    ) {
      return paymentConfigs[0].name
    }

    return ''
  }

  getGpsPaymentConfigDisplayName = (type, gpsPaymentList = {}) => {
    const paymentKey = findGpsOptionKey(gpsPaymentList, type)
    const paymentConfigs = paymentKey ? gpsPaymentList[paymentKey] : []

    if (
      Array.isArray(paymentConfigs) &&
      paymentConfigs.length > 0 &&
      paymentConfigs[0].displayName
    ) {
      return paymentConfigs[0].displayName
    }

    return ''
  }

  getGpsPaymentConfigType = (type, gpsPaymentList = {}) => {
    const paymentKey = findGpsOptionKey(gpsPaymentList, type)
    const paymentConfigs = paymentKey ? gpsPaymentList[paymentKey] : []

    if (
      Array.isArray(paymentConfigs) &&
      paymentConfigs.length > 0 &&
      paymentConfigs[0].type
    ) {
      return paymentConfigs[0].type
    }

    return ''
  }

  // A non-internal processorURL indicates an external GPS-routed payment.
  findPaymentTypeFromProcessorUrl = (type, gpsPaymentOptionsList = {}) => {
    const paymentKey = findGpsOptionKey(gpsPaymentOptionsList, type)
    const gpsPaymentOption = paymentKey ? gpsPaymentOptionsList[paymentKey] : []
    const processorURL = (
      (Array.isArray(gpsPaymentOption) && gpsPaymentOption[0]?.processorURL) ||
      ''
    ).toLowerCase()

    if (processorURL && !processorURL.startsWith('internal')) {
      return GPS
    }

    return type
  }

  getUnpaidPaymentProperties = (
    gpsName,
    gpsDisplayName,
    type,
    gpsPaymentList
  ) => {
    const shouldAddPaymentTypeOption = this.shouldHandleSubscriptionPayment()
    const paymentOptionType = this.getGpsPaymentConfigType(type, gpsPaymentList)
    if (isSepaPaymentType(gpsName) && this.iBanValue) {
      const sepaProperties = {
        // Twikey rejects IBANs containing whitespace.
        iban: this.iBanValue.replace(/\s+/g, '').toUpperCase(),
        displayName: gpsDisplayName || 'SEPA',
      }
      if (shouldAddPaymentTypeOption) {
        sepaProperties.paymentTypeOption = type
      }
      if (paymentOptionType) {
        sepaProperties.paymentOptionType = paymentOptionType
      }
      return sepaProperties
    }

    const gpsPaymentProperties = {
      displayName: this.getGpsPaymentConfigDisplayName(type, gpsPaymentList),
    }
    if (shouldAddPaymentTypeOption) {
      gpsPaymentProperties.paymentTypeOption = type
    }

    if (gpsPaymentProperties.displayName) {
      if (paymentOptionType) {
        gpsPaymentProperties.paymentOptionType = paymentOptionType
      }
      return gpsPaymentProperties
    }

    if (!gpsDisplayName && !shouldAddPaymentTypeOption && !paymentOptionType) {
      return undefined
    }

    const properties = {}
    if (gpsDisplayName) {
      properties.displayName = gpsDisplayName
    }
    if (shouldAddPaymentTypeOption) {
      properties.paymentTypeOption = type
    }
    if (paymentOptionType) {
      properties.paymentOptionType = paymentOptionType
    }
    return properties
  }

  getUnpaidPaymentHeaders = () =>
    this.shouldHandleSubscriptionPayment()
      ? { 'x-nuskin-category': 'Subscription' }
      : undefined

  // The GPS options key can be a content-managed label ('SEPA Direct Debit'),
  // so the name comes from the option id and falls back to the canonical 'SEPA'.
  // Twikey is the legacy name, used only when the market exposes no SEPA option.
  getSepaPaymentName = (gpsPaymentList = {}) => {
    const gpsOptions =
      Object.keys(gpsPaymentList || {}).length > 0
        ? gpsPaymentList
        : this.globalPaymentResponse || {}
    const sepaKey = findGpsOptionKey(gpsOptions, SEPA)
    if (!sepaKey) {
      return TWIKEY_PAYMENT_NAME
    }
    const sepaOption = gpsOptions[sepaKey]?.[0] || {}
    return getGpsOptionId(sepaOption) || SEPA.toUpperCase()
  }

  getPaymentName = (gpsName, gpsPaymentList) => {
    if (isSepaPaymentType(gpsName)) {
      return this.getSepaPaymentName(gpsPaymentList)
    }

    return this.getGpsPaymentConfigName(gpsName, gpsPaymentList) || gpsName
  }

  resolveGpsOptionIdentity = (paymentTypeValue, gpsPaymentList = {}) => {
    const gpsOptions =
      Object.keys(gpsPaymentList).length > 0
        ? gpsPaymentList
        : this.globalPaymentResponse || {}
    const paymentKey = findGpsOptionKey(gpsOptions, paymentTypeValue)
    const gpsOption = (paymentKey && gpsOptions[paymentKey]?.[0]) || {}
    return {
      type: resolveGpsPaymentType(gpsOption, paymentKey),
      id: getGpsOptionId(gpsOption, paymentKey),
    }
  }

  // Express wallet buttons build their own payload, so they resolve type/name
  // from the GPS response to match the regular checkout contract.
  getExpressPaymentIdentity = (paymentType = '') => {
    const braintreeIdentity = {
      type: paymentType,
      name: paymentType.toLowerCase(),
    }

    if (!isGPSEnabled()) {
      return braintreeIdentity
    }

    const { type, id } = this.resolveGpsOptionIdentity(paymentType)
    return id ? { type, name: id } : braintreeIdentity
  }

  // For one-time orders, GPS ("type":"GPS") redirection payments always save
  // the payment to profile; subscription orders keep the existing behaviour.
  //For sepa payments, always pass addPaymentToProfile as true
  getPaymentHeader = (paymentType, selectedPaymentOption) => ({
    addPaymentToProfile: isSepaPaymentType(selectedPaymentOption)
      ? true
      : paymentType === GPS && !cartContainer.hasSubscriptionProduct(),
    useDefaultPayment: false,
    setAsDefaultPaymentInProfile: false,
  })

  saveToProfilePaymentTypes = new Set([
    GPS,
    'PAYPAL',
    'APPLEPAY',
    'GOOGLEPAY',
    'KLARNA',
  ])

  getSaveToProfilePaymentType = paymentType =>
    this.saveToProfilePaymentTypes.has(paymentType) ? GPS : paymentType

  isBankTransferPaymentType = (...values) =>
    values.some(value => {
      const normalizedValue = (value || '').toLowerCase()
      return (
        normalizedValue === 'wire' ||
        normalizedValue === BANK_TRANSFER_TYPE.toLowerCase()
      )
    })

  // Wire is stored once per profile, so a newly added wire must reuse the
  // existing BANKTRANSFER payment reference instead of creating a duplicate.
  // Subscription dashboard populates paymentsForDashboard rather than
  // paymentResponse, so both sources are checked.
  getSavedBankTransferPaymentRefId = () => {
    const savedPayments = [
      ...(customerContainer?.paymentsForDashboard?.payments || []),
      ...(customerContainer?.paymentResponse?.payments || []),
    ]
    const savedWirePayment = savedPayments.find(payment =>
      this.isBankTransferPaymentType(payment?.type, payment?.name)
    )
    return savedWirePayment?.id || ''
  }

  handleUnpaidPayment = async (type, bagValue, gpsPaymentList = {}) => {
    overlayState.showLoader()
    const paymentTypeValue = type || ''
    // GPS returns the option under keys of varying case (e.g. "SEPA", "PayPal").
    const normalizedPaymentType = paymentTypeValue.toLowerCase()
    const isSepaPayment = isSepaPaymentType(normalizedPaymentType)
    const { typeMap } = this.getUnpaidPaymentConfig(paymentTypeValue)
    const mappedType = typeMap[paymentTypeValue] || paymentTypeValue
    let gpsName = normalizedPaymentType
    let gpsDisplayName = ''

    const { type: paymentType, id: gpsOptionIdFromResponse } =
      this.resolveGpsOptionIdentity(paymentTypeValue, gpsPaymentList)
    if (paymentType === GPS) {
      gpsDisplayName = await this.getPaymentDisplayName(
        paymentTypeValue,
        gpsPaymentList
      )
      const processorName = this.getGpsPaymentConfigName(
        mappedType,
        gpsPaymentList
      )
      gpsName = mappedType
      if (processorName) {
        gpsName = processorName
      }
      if (getGPSConfigValue('enableGPSRedesignFlow')) {
        checkoutContainer.isToInitiateGlobalPayment = true
      }
    }

    if (this.shouldExtractGpsPaymentConfigName(paymentTypeValue)) {
      const paymentConfigName = this.getGpsPaymentConfigName(
        paymentTypeValue,
        gpsPaymentList
      )
      if (paymentConfigName) {
        gpsName = paymentConfigName
      }
    }

    const properties = this.getUnpaidPaymentProperties(
      gpsName,
      gpsDisplayName,
      paymentTypeValue,
      gpsPaymentList
    )

    // SEPA resolves its name from the GPS SEPA option id (Twikey fallback)
    // rather than the generic displayName rules.
    const paymentName = isSepaPayment
      ? this.getSepaPaymentName(gpsPaymentList)
      : gpsOptionIdFromResponse ||
        gpsDisplayName ||
        this.getPaymentName(gpsName, gpsPaymentList)

    const savedBankTransferPaymentRefId = this.isBankTransferPaymentType(
      paymentTypeValue,
      mappedType,
      gpsName,
      paymentName
    )
      ? this.getSavedBankTransferPaymentRefId()
      : ''

    const postData = [
      {
        name: paymentName,
        isDefault: false,
        status: 'active',
        type: paymentType,
        ...(properties && { properties }),
        ...(savedBankTransferPaymentRefId && {
          paymentItems: [{ paymentRefId: savedBankTransferPaymentRefId }],
        }),
        amount: bagValue,
        option: this.getPaymentHeader(
          this.getSaveToProfilePaymentType(paymentType),
          normalizedPaymentType
        ),
        isValid: true,
      },
    ]
    const response = await checkoutContainer.addAlternatePayment(
      postData,
      this.getUnpaidPaymentHeaders()
    )

    if (APPConfig?.getAppConfig()?.enableCheckoutAPIAfterPayment) {
      await checkoutContainer.handleViewCart(response)
    }

    if (getDefaultPaymentMethod() === 'razorpay') {
      trackCustomCheckoutEvent({
        eventType: 'payment',
        cartResponse: cartContainer?.cartResponse,
      })
    }
    overlayState.hideLoader()
    return { ...response, gpsDisplayName }
  }

  /**
   * Derives order_type value for PathToPurchase analytics payload.
   */
  getPathToPurchaseOrderType = (cartData, contextValue) => {
    const items = cartData?.items
    if (Array.isArray(items) && items.length) {
      const hasSubscription = items.some(item => item?.isSubscription)
      const hasNonSubscription = items.some(
        item =>
          !item?.isSubscription &&
          !item?.properties?.isAutoFreebie &&
          !item?.properties?.isGiftItem
      )

      if (hasSubscription && hasNonSubscription) {
        return 'mixed'
      }

      if (hasSubscription) {
        return 'subscription'
      }

      if (hasNonSubscription) {
        return 'one-time'
      }
    }

    const orderTypeProp = cartData?.properties?.orderType
    if (orderTypeProp) {
      return `${orderTypeProp}`.toLowerCase().replace(/\s+/g, '-')
    }

    switch (contextValue) {
      case 'personal_offer':
        return 'personal-offer'
      case 'storefront':
        return 'group-offer'
      default:
        return ''
    }
  }

  /**
   * Collects affiliate, distributor, and pitch metadata for analytics push.
   */
  getAffiliateTrackingDetails = (contextValue, cartData) => {
    const defaultDetails = {
      affiliateLink: '',
      distributorId: '',
      offerPitchId: '',
      itemAffiliation: '',
    }

    if (!IS_BROWSER) {
      return defaultDetails
    }

    if (contextValue === 'personal_offer') {
      let personalOffer = getSessionStorage('personalOffer') || {}
      if (typeof personalOffer === 'string') {
        const personalOfferString = personalOffer
        try {
          personalOffer = JSON.parse(personalOfferString)
        } catch (error) {
          trackErrorInInstana({
            errorReport: 'Failed to parse personalOffer session data',
            errorData: {
              error: error?.message || error,
              rawValue: personalOfferString,
            },
          })
          personalOffer = {}
        }
      }

      let personalOfferV2 = getLocalStorage('personalOffer_v2') || {}
      if (typeof personalOfferV2 === 'string') {
        const personalOfferV2String = personalOfferV2
        try {
          personalOfferV2 = JSON.parse(personalOfferV2String)
        } catch (error) {
          trackErrorInInstana({
            errorReport: 'Failed to parse personalOffer_v2 local data',
            errorData: {
              error: error?.message || error,
              rawValue: personalOfferV2String,
            },
          })
          personalOfferV2 = {}
        }
      }

      const pitchDetails =
        personalOffer?.pitchDetails || personalOffer?.offer || {}

      const distributorId =
        pitchDetails?.sponsorSapId ||
        pitchDetails?.sapId ||
        personalOffer?.sapId ||
        personalOffer?.sponsorSapId ||
        ''

      const offerPitchId =
        pitchDetails?.pitchID ||
        pitchDetails?.pitchId ||
        personalOffer?.offerId ||
        personalOffer?.pitchID ||
        personalOffer?.pitchId ||
        personalOfferV2?.pitchID ||
        personalOfferV2?.pitchId ||
        ''

      return {
        affiliateLink:
          personalOffer?.landingPageURL || personalOffer?.landingPageUrl || '',
        distributorId,
        offerPitchId,
        itemAffiliation: distributorId || 'nuskin',
      }
    }

    if (contextValue === 'storefront') {
      const sponsorId =
        mysiteContainer?.mysiteSponsor ||
        getSessionStorage('sponsor') ||
        cartData?.properties?.mysiteSponsorId ||
        ''

      return {
        affiliateLink: getMysiteCartUrl() || '',
        distributorId: sponsorId,
        offerPitchId: 'NA',
        itemAffiliation: sponsorId || 'nuskin',
      }
    }

    const sponsorId =
      accountsContainer?.getUserTypeSponsorId?.() ||
      cartData?.properties?.mysiteSponsorId ||
      ''

    return {
      affiliateLink: 'NA',
      distributorId: sponsorId,
      offerPitchId: 'NA',
      itemAffiliation: sponsorId || 'nuskin',
    }
  }

  /**
   * Store GTM data for checkout purchase event into the local storage.
   */
  storeGTMDataInLocalStorage = globalPaymentInitiateResponse => {
    const gtmData = cartContainer?.cartResponse || {}
    const dataToStore = {
      properties: {
        orderType: gtmData?.properties?.orderType,
        oneTimeItemsTotal: gtmData?.properties?.oneTimeItemsTotal || 0,
      },
      userId: gtmData?.userId || '',
      value: {
        overAllTax: gtmData?.value?.overAllTax || '',
        cartDeliveryCharge: gtmData?.value?.cartDeliveryCharge || '',
      },
      promotionDetails: {
        codes: [{ code: gtmData?.promotionDetails?.codes?.[0]?.code || '' }],
      },
      payments: [{ name: gtmData?.payments?.[0]?.name || '' }],
      deliveryDetails: {
        methods: gtmData?.deliveryDetails?.methods,
      },
      items: gtmData?.items,
      currencyCode: gtmData?.currencyCode || '',
    }
    const storedGtmData = getLocalStorage('gtmDataForCheckoutPurchase')
    const paymentId =
      globalPaymentInitiateResponse?.transaction?.properties?.filter(
        item => item?.name === 'confirmationCode'
      )?.[0]?.value || ''
    const updatedDataToStore = {
      ...storedGtmData,
      [paymentId]: dataToStore || {},
    }
    setLocalStorage('gtmDataForCheckoutPurchase', updatedDataToStore)
  }

  /**
   * Pushes checkout purchase event into the GTM data layer.
   */
  prepareGTMPurchaseData = (orderId = '', paymentId = '') => {
    let gtmData = cartContainer?.cartResponse
    if (
      !gtmData ||
      Object.keys(gtmData).length === 0 ||
      gtmData?.status === 'failure'
    ) {
      try {
        const storedGtmData = getLocalStorage('gtmDataForCheckoutPurchase')
        gtmData = storedGtmData?.[paymentId] || {}
      } catch (e) {
        gtmData = {}
      }
    }
    const contextValue = checkMysiteOrPersonalOffer()
    let gtmOrderType = gtmData?.properties?.orderType || 'Standard'
    if (contextValue === 'storefront') {
      gtmOrderType = 'Group offers'
    } else if (contextValue === 'personal_offer') {
      gtmOrderType = 'Personal offers'
    }
    const enableEQFastFollow =
      convertToBoolean(APPConfig?.getAppConfig()?.enableEQFastFollow) || false
    const enablePaymentAndShippingTierGTM =
      convertToBoolean(
        APPConfig?.getAppConfig()?.enablePaymentAndShippingTierGTM
      ) || false
    const userTypeSponsorId = accountsContainer?.getUserTypeSponsorId() || ''
    const guestSignupOrigin = getGuestSignupOrigin() || ''
    const actionField = {
      memberId: gtmData?.userId || '',
      orderType: gtmOrderType,
      affiliation: 'Online Store',
      revenue: gtmData?.properties?.oneTimeItemsTotal || 0,
      tax: gtmData?.value?.overAllTax || '',
      shipping: gtmData?.value?.cartDeliveryCharge || '',
      coupon: gtmData?.promotionDetails?.codes?.[0]?.code || '',
      action: 'purchase',
      id: orderId,
    }

    if (enableEQFastFollow) {
      actionField.sponsor_id = userTypeSponsorId || ''
      actionField.origin = guestSignupOrigin || ''
    }
    let purchaseActionField = { ...actionField }
    if (enablePaymentAndShippingTierGTM) {
      purchaseActionField.payment_tier = gtmData?.payments?.[0]?.name || ''
      purchaseActionField.shipping_tier =
        gtmData?.deliveryDetails?.methods?.find(m => m?.isSelected)?.id || ''
    }

    return { gtmData, purchaseActionField }
  }

  /**
   * Pushes PathToPurchase purchase event into the GTM data layer.
   */
  pushPathToPurchasePurchaseEvent = () => {
    const gtmData = cartContainer?.cartResponse || {}
    const contextValue = checkMysiteOrPersonalOffer()
    const cartData = gtmData
    const orderId = checkoutContainer.orderId

    if (!IS_BROWSER) {
      return
    }

    if (
      !cartData ||
      !Array.isArray(cartData?.items) ||
      !cartData.items.length
    ) {
      return
    }

    try {
      const promotionCodes = cartData?.promotionDetails?.codes
      const primaryCode =
        Array.isArray(promotionCodes) && promotionCodes.length
          ? promotionCodes[0]
          : ''
      const couponCode =
        (primaryCode && typeof primaryCode === 'string'
          ? primaryCode
          : primaryCode?.code ||
            primaryCode?.couponCode ||
            primaryCode?.promotionCode) ||
        cartData?.promotionDetails?.code ||
        ''

      const affiliateDetails = this.getAffiliateTrackingDetails(
        contextValue,
        cartData
      )

      const orderType = this.getPathToPurchaseOrderType(cartData, contextValue)

      if (enableNewFeature('enableCheckoutPurchaseGTMEvent')) {
        trackPathToPurchasePurchaseEvent({
          cartData,
          orderId,
          affiliateLink: affiliateDetails.affiliateLink,
          distributorId: affiliateDetails.distributorId,
          offerPitchId: affiliateDetails.offerPitchId,
          orderType,
          couponCode,
          itemAffiliation: affiliateDetails.itemAffiliation,
        })
      }

      if (enableNewFeature('enablePixelTracking')) {
        trackSalesAIPixelPurchaseEvent({
          cartData,
          orderId,
          accountId: customerContainer?.accountId || '',
          personId: customerContainer?.personId || '',
        })
      }
    } catch (error) {
      trackErrorInInstana({
        errorReport: 'PathToPurchase purchase event push failed',
        errorData: {
          error: error?.message || error,
          orderId,
        },
      })
    }
  }

  /**
   * Checks if a card type is missing in the GPS (Global Payment System) supported cards list.
   *
   * @param {string} cardType - The card type to check (e.g., 'VISA', 'DISCOVER')
   * @returns {boolean} - Returns true if card type is not supported by GPS, false otherwise
   */
  isCardTypeSupportedInGPS = cardType => {
    if (!cardType) {
      return true
    }
    const creditCardData = this.globalPaymentResponse?.['CREDITCARD'] || []
    // GPS display names may contain spaces (e.g. 'AMERICAN EXPRESS') while card types don't
    const normalizeCardName = name =>
      (name || '').toString().toUpperCase().replace(/\s+/g, '')
    const supportedCardsFromAPI = creditCardData
      .map(card => normalizeCardName(card?.displayName))
      .filter(Boolean)
    const isSupported = supportedCardsFromAPI.includes(
      normalizeCardName(cardType)
    )
    return isSupported
  }

  /**
   * Checks if a card should be restricted based on GPS (Global Payment System) settings.
   *
   * @param {string} cardType - The card type to check (e.g., 'VISA', 'DISCOVER')
   * @returns {boolean} - Returns true if card should be restricted, false otherwise
   */
  shouldRestrictCardBasedOnGPS = cardType => {
    const enableGlobalPaymentSystem = isGPSEnabled()
    const restrictCreditCardTypesFromGPS = isFeatureEnabled(
      'restrictCreditCardTypesFromGPS'
    )
    return (
      enableGlobalPaymentSystem &&
      restrictCreditCardTypesFromGPS &&
      !this.isCardTypeSupportedInGPS(cardType)
    )
  }

  /**
   * Checks if the card is a Discover card being used in Canada market.
   *
   * @param {string} cardType - The card type to check (e.g., 'discover', 'DISCOVER')
   * @returns {boolean} - Returns true if it's a Discover card in Canada, false otherwise
   */
  isDiscoverInCanada = cardType => {
    return (
      storeContainer?.storeIDValue?.toLowerCase() === 'canada' &&
      cardType?.toUpperCase() === 'DISCOVER'
    )
  }

  /**
   * Validates if a card is allowed for payment based on GPS restrictions and market rules.
   * Combines GPS restriction check and Discover in Canada check.
   *
   * @param {string} cardType - The card type to check
   * @returns {boolean} - Returns true if card is NOT allowed, false if card is allowed
   */
  isGPSorDiscoverRestricted = cardType => {
    const provider = (cardType || '').toString().toUpperCase()
    return (
      isCardProviderRestricted(provider) ||
      this.shouldRestrictCardBasedOnGPS(cardType) ||
      this.isDiscoverInCanada(cardType)
    )
  }

  updateGPSLocalStorageAfterPaymentRedirection = paymentId => {
    const storedGtmData = getLocalStorage('gtmDataForCheckoutPurchase') || {}
    const orderMapping = getLocalStorage('OrdersMapping') || {}
    const paymentData = storedGtmData?.[paymentId] || {}
    delete storedGtmData[paymentId]
    delete orderMapping[paymentId]
    setLocalStorage('gtmDataForCheckoutPurchase', storedGtmData)
    setLocalStorage('OrdersMapping', orderMapping)
  }

  /**
   * Handles the selection of a pickup location for the M3 shipping method.
   * Updates the cart with the selected pickup location details.
   *
   * @param {Object} location - The selected pickup location object
   * @param {Object} context - Context object containing component state setters
   * @param {Function} context.setSelectedPickupLocation - Function to set the selected pickup location in component state
   * @param {Function} context.setSelectedShippingMethodId - Function to set the selected shipping method ID in component state
   * @param {Function} context.setShowList - Function to set the showList state in component
   * @param {Function} context.handleClick - Function to handle shipping method selection
   * @returns {Promise} Promise that resolves when the pickup location is saved
   */
  handlePickupLocationSelect = async (location, context) => {
    const {
      setSelectedPickupLocation,
      setSelectedShippingMethodId,
      setShowList,
      handleClick,
    } = context

    setSelectedPickupLocation(location)
    try {
      const selectedPickupData = {
        serviceGroup: location.serviceGroup,
        id: location.id,
        carrier: location.carrier,
        name: location.name,
        street: location.street || location.address,
        city: location.city,
        postalCode: location.postalCode,
        distance: location.distance,
        locker: location.locker ?? null,
        unit: location.unit,
        openingHours: location.openingHours || location.hours,
        latitude: location.latitude ?? location.position?.lat,
        longitude: location.longitude ?? location.position?.lng,
        carrierCode: location.carrierCode,
      }

      // Find only the pickup method
      const shippingMethods =
        cartContainer?.cartResponse?.deliveryDetails?.methods || []

      const pickupMethod = shippingMethods.find(
        method =>
          method?.id?.toLowerCase() === PICKUP_SHIPPING_METHOD_ID?.toLowerCase()
      )

      if (!pickupMethod) {
        console.error('Pickup method not found')
        return
      }

      // If M3 is not currently selected, select it first
      if (!pickupMethod.isSelected) {
        await handleClick(PICKUP_SHIPPING_METHOD_ID)
      }

      // Store pickup location in cart properties
      const loadParams = {
        endPointName: 'updateBagAttributes',
        method: 'PATCH',
        postData: {
          properties: {
            pickupLocation: JSON.stringify(selectedPickupData),
          },
        },
      }

      const response = await this.fetchResponse(loadParams)
      if (this.isSuccessResponse(response)) {
        // Refresh cart to get updated properties
        await cartContainer.viewCart()
        // Update selected shipping method ID
        setSelectedShippingMethodId(PICKUP_SHIPPING_METHOD_ID)
        // Close the accordion automatically after a short delay
        // Clear any existing timeout before setting a new one
        if (this.pickupLocationTimeoutId) {
          clearTimeout(this.pickupLocationTimeoutId)
        }
        const isRecipientFormEnabled = isFeatureEnabled(
          'enablePickupRecipientForm'
        )
        if (!isRecipientFormEnabled) {
          this.pickupLocationTimeoutId = setTimeout(() => {
            setShowList(false)
            this.pickupLocationTimeoutId = null
          }, 100)
        }
      } else {
        console.error('Failed to save pickup location:', response)
      }
    } catch (error) {
      console.error('Error saving pickup location to cart:', error)
    }
  }

  /**
   * Clears the pickup location timeout if it exists.
   * Should be called when component unmounts to prevent memory leaks.
   */
  clearPickupLocationTimeout = () => {
    if (this.pickupLocationTimeoutId) {
      clearTimeout(this.pickupLocationTimeoutId)
      this.pickupLocationTimeoutId = null
    }
  }
}
const checkoutContainer = new CheckoutContainer()

export { CheckoutContainer, checkoutContainer }
export default checkoutContainer
